import { createI18n } from "vue-i18n";

export default createI18n({
  legacy: false,
  locale: localStorage.getItem("locale") || "nl",
  fallbackLocale: "nl",
  messages: {
    en: {
      nav: {
        people: "People",
        organogram: "Organogram",
        timesheet: "Timesheet",
        leave: "Leave",
        projects: "Projects",
        projectAdmin: "Project administration",
        dashboard: "Dashboard",
        incompleteTimeEntries: "Timesheets",
        projectIntake: "Project intake",
        compass: "Compass",
        myProjects: "My projects",
        adminDocumentation: "Admin documentation",
        help: "Help",
        outlookSignature: "Email signature",
        helpSupport: "Help & support",
        feedback: "Feedback",
        installApp: "Install",
      },
      appBarAvatarCard: {
        editProfile: "Edit profile",
        logOut: "Log out",
      },
      avatarCard: {
        addSkillsButton: "Add some skills to your profile!",
      },
      people: {
        search: "Search",
        newEmployeeRibbon: "New colleague",
        newEmployeesModal: {
          title: "Welcome new colleagues!",
        },
        sort: {
          label: "Sort by",
          toggleSortOrderTip: "Toggle sort order",
          options: {
            givenName: "First name",
            surname: "Last name",
            department: "Department",
            mail: "E-mail",
            officeLocation: "Office",
            jobTitle: "Job title",
          },
        },
      },
      organogram: {
        appBarTitle: "Organogram",
        selectDepartment: "Select department",
        selectOffice: "Select office",
      },
      timesheet: {
        exportToExcel: "Export to Excel",
        filterCurrentWeekButton: "Filter current week",
        filterLeaveButton: "Filter leave",
        expandAllButton: "Expand all",
        collapseAllButton: "Collapse all",
        selectYear: "Year",
        selectUser: "User",
        sidebar: {
          filters: "Filters",
          columns: "Columns",
        },
        workLocation: {
          office: "Office Vicoma",
          onsite: "Onsite customer",
          home: "Home",
        },
        gridTips: {
          title: "New: columns and filters",
          intro:
            "On the right side of the table you'll find two tabs: Filters and Columns. Use them to choose what you see.",
          filters: {
            title: "Filters",
            text: "Open the Filters tab and filter on, for example, a project, task or status. Click the tab again to close the panel.",
          },
          columns: {
            title: "Columns",
            text: "In the Columns tab, tick a column to add it to the table, such as Description, Work location, Customer or Hour code. Untick it to remove it again.",
          },
          expand: {
            title: "Expand all",
            text: "After adding or removing a column, the table is rebuilt and collapsed. Use 'Expand all' to see every row again.",
          },
          helpHint:
            "You only see this message once. You can read it again under Help > Registering hours.",
          gotIt: "Got it",
        },
        grid: {
          noUserFound: "No user found",
          errorLoadingMessage: "Error loading user data",
          loadingMessage: "Loading data for",
          holidayWarning:
            'Warning: Public holiday - Use task "HR-Feestdag(en) / Public holidays"',
        },
        hours: "h",
        tooLittle: "short",
        headers: {
          date: "Date",
          project: "Project",
          task: "Task",
          description: "Description",
          status: "Status",
        },
      },
      leave: {
        totalLeaveHeader: "Leave entitlement",
        daysLeft: "days left",
        hours: "hours",
        days: "days",
        remaining: "remaining",
        short: "short",
        hoursUsedThisYear: "hours used",
        hoursPaidOut: "hours paid out",
        hoursCorrected: "correction",
        hoursExpired: "hours expired",
        totalLeaveHours: "total leave hours",
        includeFeatureLeave: "Show feature leave",
        annualLeave: "Leave",
        overtime: "Overtime",
        tvtSpared: "Time for time accrued",
        overtimeSpared: "overtime accrued",
        termsOfEmployment: "Terms of employment",
        tooltipLeaveTotal: `Your total leave includes (boven) wettelijk, leef/diensttijd verlof, ADV hours and overtime. { lineBreak }
        Refer to the { termsPage } chapter 5 paragraph 1 for more information.`,
        tooltipLeaveStatutory: `Leave includes your (boven) wettelijk, leef/diensttijd verlof. { lineBreak }
        Refer to the { termsPage } chapter 5 paragraph 1 for more information.`,
        tooltipLeaveAdv: `Refer to the { termsPage } chapter 6 for more information.`,
        tooltipTvt: `Refer to the { termsPage } chapter 11 for more information.`,
        nextUser: "Next user",
        hr2dayForbidden: "Leave balances of other employees are only available to full admins.",
        hr2dayEmployeeNotFound: "No employee number found for this user in Entra ID.",
        hr2dayUnavailable: "Leave balances from HR2Day could not be loaded.",
        hr2dayEntraUnavailable: "Employee details could not be retrieved from Entra ID, so leave balances could not be loaded.",
      },
      projects: {
        pageTitle: "Projects",
        internal: "Non-billable",
        external: "Billable",
        projectCardDescription: "Internal and billable projects",
        projectCardTooltip:
          "Shows the number of projects worked on in the selected period, split into internal and billable (external) projects.",
        hoursCardTitle: "Hours",
        hoursCardDescription: "Total hours spent on projects",
        hoursCardTooltip:
          "Shows the total hours booked in the selected period, per client or per project (use the Clients / Projects switch). The number in the middle is the total.",
        hoursCardViewClients: "Clients",
        hoursCardViewProjects: "Projects",
        productivityCardDescription: "Productive vs. non-productive hours",
        productivityCardTitle: "Productivity",
        productivityCardTooltip:
          "Hours on client projects divided by hours on client projects plus hours on internal projects (including department tasks on the department project), rounded to whole percentages. Leave and sick leave (HR tasks) do not count. Example: 30 h client projects, 10 h department tasks, 8 h leave = 75%.",
        projectCounter: {
          unit: "project | projects",
          empty: "No projects in this period",
        },
        chartCenter: {
          totalHours: "Total hours",
          average: "Average",
        },
        hours: "hours",
        billableHours: "Productivity",
        dateRange: {
          label: "Period",
          apply: "Apply",
          cancel: "Cancel",
          currentWeek: "Current week",
          previousWeek: "Previous week",
          thisMonth: "This month",
          lastMonth: "Last month",
          yearToDate: "Year to date",
        },
        grid: {
          client: "Client",
          telephone: "Telephone",
          actions: "Actions",
          projectNumber: "Project number",
          projectName: "Project name",
          active: "Active",
          inactive: "Inactive",
          hoursBudget: "Hours budget",
          billingMethod: "Billing method",
          timeAndMaterial: "Time and material",
          fixedPrice: "Fixed price",
          loadingMessage: "Loading data...",
          noRowsMessage: "No projects found for this period",
          errorLoadingMessage: "Error loading data",
          noUserFound: "No user found",
        },
        budget: {
          noBudget: "No budget",
          hoursShort: "h",
        },
        hoursStatus: {
          title: "Hours budget",
          unknown: "Unknown",
          noData: "No booked hours found for this project",
          error: "Could not load hours by department",
          columnTask: "Task",
          columnProgress: "Progress",
          columnHours: "Hours",
          expandAll: "Expand all",
          collapseAll: "Collapse all",
        },
        progressOverTime: {
          title: "Trend & forecast",
          noData: "No booked hours found for this project",
          error: "Could not load progress over time",
          seriesBooked: "Booked hours",
          seriesCumulative: "Cumulative",
          seriesProjected: "Projection",
          seriesPercentOfBudget: "% of budget",
          budgetLine: "Budget: {hours} h",
          budgetLinePercent: "Budget (100%)",
          viewTotal: "Total",
          viewDiscipline: "By discipline",
          viewDisciplineTooltip:
            "By discipline, the bars show booked hours per week (stacked). The lines show the cumulative total as a % of each discipline's own budget, so disciplines with different budgets can be compared. The dashed line is the forecast at that discipline's recent pace. Click a discipline in the legend to show or hide it.",
          viewDisciplineUnavailable:
            "The breakdown by discipline is available when hours are booked or budgeted on more than one discipline.",
          noDiscipline: "No discipline",
          otherDisciplines: "Other ({count})",
          noBudget: "no budget",
          table: {
            discipline: "Discipline",
            budget: "Budget",
            booked: "Booked",
            percent: "% budget",
            recentPace: "Recent pace",
            endDate: "Expected end",
          },
          kpi: {
            remainingBudget: "Remaining budget",
            recentPace: "Recent pace",
            recentPaceTooltip:
              "Weighted average of the last {weeks} completed weeks, with recent weeks counting more (last week ×{weeks}, oldest ×1). This way the pace follows the phase the project is in (start-up, peak or wind-down). Weeks without bookings count as 0. The current week is excluded because hours are often booked later. The average over the whole period is shown below for comparison.",
            lifetimePace: "Lifetime average: {pace}",
            week: "week",
            endDate: "Expected end",
            endDateTooltip:
              "Based on the recent pace: when the remaining budget is expected to run out, counted from today. If no hours were booked in the last {weeks} weeks, the project is stalled and there is no forecast. If the budget has already been reached, this shows the week in which that happened. Note: in a project's wind-down phase the pace usually keeps dropping, so this date is then on the optimistic side.",
            activePeriod: "Active period",
            activePeriodTooltip:
              "Number of calendar weeks from the first booked hour entry up to and including last week, including weeks without bookings (also when the project is currently stalled). The lifetime average is calculated over this period.",
            budgetReached: "Budget reached on {date}",
            projectedEnd: "Expected at this pace: {date}",
            stalled: "Stalled since {date}",
            unknown: "Unknown",
            activeWeeks: "{weeks} weeks",
          },
        },
        detailHelp: {
          hoursStatus: {
            intro:
              "How much of this project's hours budget has been used. At the top is the bar for the whole project, below it one bar per discipline. Expand a discipline to see the roles or tasks under it, each with its own bar.",
            readIntro:
              "Each bar shows the percentage of the budget that has been used, with the booked hours against the budget on the right. The colour tells you at a glance how things stand:",
            examples: {
              withinBudget: "Green: within budget. Here 60 of the 100 budgeted hours have been used.",
              overBudget: "Red: over budget. More hours were booked than budgeted, so the hours on the right turn red too.",
              bookedWithoutBudget: "Full red bar with 'no budget': hours were booked on something that has no budget.",
              noBudget: "Just 'no budget' (grey): there is no budget and no hours have been booked yet.",
            },
            use1: "Click a discipline to expand or collapse the roles or tasks under it.",
            use2: "Use the 'Expand all' / 'Collapse all' button above the list to open or close all disciplines at once.",
            use3: "Disciplines and tasks are sorted by budget, largest first. Hover over a truncated name to see it in full.",
            faq: {
              q1: "Which hours count as booked?",
              a1: "Every hour entry on the project, including drafts and hours that have not been submitted or approved yet. Only cancelled and returned hours are left out; a returned hour counts again once it has been corrected and resubmitted. Hours budget and Trend & forecast use exactly the same hours, so their totals match. The figures can differ slightly from the financial administration in Dynamics, which only counts hours after approval and processes corrections separately.",
              q2: "Where does the budget come from and how do I change it?",
              a2: "The budget is the sum of the budgeted hours on the project tasks in Dynamics. This app only reads it; you change it in Dynamics (or ask the project lead). After a change, you will see the new budget when you reopen this page.",
              q3: "Why is a task shown in red with 'no budget'?",
              a3: "Hours were booked on that task while it has no budgeted hours. That can be intentional, but it often means hours were booked on the wrong task or the budget has not been filled in yet.",
            },
          },
          progress: {
            intro:
              "How the booked hours build up week by week against the budget, and when the budget is expected to run out at the current pace. At the top are four tiles:",
            kpi: {
              remainingBudget: "how many hours of the budget are left.",
              recentPace:
                "how many hours were booked per week on average over the last {weeks} weeks, with recent weeks counting more. The average over the whole period is shown below for comparison.",
              endDate: "when the remaining budget runs out at the recent pace, or in which week the budget was already reached.",
              activePeriod: "how many weeks have passed since the first booking, up to and including last week.",
            },
            sketchAlt:
              "Sketch of the chart: blue bars per week, a green cumulative line, a red dashed budget line and a dashed forecast line, with numbered markers.",
            chart1: "Blue bars: hours booked per week (left axis).",
            chart2: "Green line: the cumulative total, i.e. all hours up to and including that week added together (right axis).",
            chart3: "Red dashed line: the budget. Where the green line reaches it, the budget has run out.",
            chart4: "Dashed green line: the forecast. This is how the cumulative total continues if the recent pace stays the same.",
            chart5: "Weeks without a bar: nothing was booked that week. The chart runs up to last week, so you can also see when a project is currently stalled.",
            discipline1:
              "Use the 'By discipline' button above the chart to split the hours out per discipline. Each discipline has its own colour.",
            discipline2:
              "The bars are stacked: the whole bar is still the weekly total, and the colours show how much each discipline booked.",
            discipline3:
              "The lines show each discipline's cumulative total as a percentage of its own budget. The red 100% line means that discipline's budget is used up. This way you can compare a small and a large discipline directly.",
            discipline4:
              "Below the chart is a table with each discipline's budget, booked hours, recent pace and expected end. 'Other' groups the smallest disciplines when there are more than seven; 'No discipline' are hours on a task that does not fall under a discipline.",
            legendIntro: "Below the chart is the legend. Use it to choose what you see:",
            legendExample: {
              a: "Discipline A",
              b: "Discipline B",
              c: "Discipline C",
            },
            legendExampleCaption:
              "Example: after double-clicking Discipline A, the others are shown faded and hidden in the chart.",
            legend: {
              click: { label: "Click", text: "shows or hides that item." },
              doubleClick: { label: "Double-click", text: "shows only that item; all others are hidden." },
              restore: {
                label: "Show everything again",
                text: "double-click the same (only visible) item once more. So you don't have to switch the others back on one by one.",
              },
              other: {
                label: "Double-click another item",
                text: "shows only that item. This lets you jump quickly from one discipline to the next.",
              },
              touch: { label: "Phone or tablet", text: "tapping an item works like clicking." },
            },
            legendGrouped:
              "In the 'By discipline' view, a discipline's bar, line and forecast share one legend item, so you always show or hide them together.",
            toggle:
              "Hover over a bar or point to see the exact figures for that week. Your choice between 'Total' and 'By discipline' is remembered for next time.",
            tip1: "Compare the recent pace with the lifetime average. If the recent pace is higher, the project is speeding up (usually the busy middle phase). If it is lower, it is slowing down or winding down.",
            tip2: "Want a close look at one discipline? Double-click it in the legend: the scale then adjusts to that discipline, so small disciplines don't disappear next to large ones. Double-click again to go back.",
            tip3: "In 'By discipline': the line that approaches the 100% line first is the discipline most likely to go over budget first.",
            tip4: "Does it say 'Stalled since …'? Then nothing was booked in the last {weeks} weeks. Check whether that is right, or whether hours ended up on another project or task.",
            tip5: "Seeing less in the chart than you expect? Some items are probably switched off in the legend. Double-click the only visible item, or reload the page.",
            faq: {
              q1: "Why doesn't the current week count towards the pace?",
              a1: "Many people book their hours at the end of the week or later. The current week is therefore almost always incomplete and would wrongly pull the pace down. This week's hours do count towards the total and the remaining budget.",
              q2: "Why do I see 'Stalled since …' instead of a date?",
              a2: "No hours were booked in the last {weeks} weeks, so there is no pace to calculate an end date with. As soon as hours are booked again, the forecast comes back automatically.",
              q3: "How reliable is the expected end date?",
              a3: "It extends the recent pace; it is not a plan. Projects usually start slowly, peak in the middle and taper off at the end. In that wind-down phase the pace keeps dropping, so the date is then on the optimistic side. Use it as a signal, not a promise.",
              q4: "Why can't I choose 'By discipline'?",
              a4: "The button is only available when hours are booked or budgeted on more than one discipline. With a single discipline the breakdown would show the same as 'Total'.",
              q5: "Which hours count as booked?",
              a5: "Every hour entry on the project, including drafts and hours that have not been submitted or approved yet. Only cancelled and returned hours are left out; a returned hour counts again once it has been corrected and resubmitted. Hours budget and Trend & forecast use exactly the same hours, so their totals match. The figures can differ slightly from the financial administration in Dynamics, which only counts hours after approval and processes corrections separately.",
              q6: "Why does a discipline have bars but no line?",
              a6: "That discipline has no budget, so there is no percentage to show. The legend and the table then say 'no budget'.",
            },
          },
        },
        detail: {
          back: "Back to projects",
          unnamed: "Project",
          buttonTooltip: "Project details",
        },
      },
      pwa: {
        updateAvailable: "New version available",
        updateDescription: "Reload to get the latest features",
        reload: "Reload",
        later: "Later",
      },
      help: {
        title: "Help center",
        common: {
          button: "Help for this page",
          title: "Help for this page",
          close: "Close",
          subtitle: "Explanations of every part of Vicoma People",
          searchPlaceholder: "Search the help center, for example ‘productivity’ or ‘legend’",
          resultCount:
            "No results for ‘{query}’ | 1 result for ‘{query}’ | {count} results for ‘{query}’",
          noResults: "Nothing found",
          noResultsHint: "Try another word, or pick a topic below.",
          newTitle: "New",
          newBadge: "New",
          categoriesTitle: "Topics",
          articleCount: "no articles | 1 article | {count} articles",
          pageHelpTip:
            "Pages with a question mark at the top right of the bar have help about that exact page. Click it whenever you get stuck.",
          home: "Help center",
          allTopics: "All topics",
          goToPage: "Go to this page",
          openInHelpCenter: "Open in the help center",
          articleNotFound: "This article does not exist (anymore), or it is not available for your account.",
          backToOverview: "Back to the overview",
          feedbackQuestion: "Was this article helpful?",
          feedbackYes: "Yes",
          feedbackNo: "No",
          feedbackThanks: "Thanks for your feedback!",
          feedbackThanksNegative: "Thanks. Still stuck? Ask your question via",
          stillQuestions: "Still have questions that are not answered here? Create a ticket via",
          supportTitle: "Need help?",
          supportText:
            "Can't find your question, or is something not working as it should? Create a ticket in Topdesk. Mention which page you were on and what you saw.",
          supportButton: "Topdesk",
          adminDocsText: "Technical and admin documentation: permissions, groups and app settings.",
          adminDocsButton: "Open",
          sections: {
            whatYouSee: "What do you see?",
            howToRead: "How to read it",
            howToUse: "How to use it",
            tips: "Handy tips",
            faq: "Frequently asked questions",
          },
        },
        categories: {
          gettingStarted: {
            title: "Getting started",
            description: "Signing in, installing and updating the app.",
          },
          people: {
            title: "People directory",
            description: "Finding colleagues and viewing their profile.",
          },
          hours: {
            title: "Hours",
            description: "Where you register hours and how you see them in the app.",
          },
          projects: {
            title: "Projects",
            description: "My projects, productivity, hours budget and trend & forecast.",
          },
          projectAdmin: {
            title: "Project administration",
            description: "For admins: following up on incomplete timesheets.",
          },
          general: {
            title: "General",
            description: "Skills, language and offline use.",
          },
        },
        articles: {
          hoursBudget: {
            summary:
              "How much of the project's hours budget has been used, per discipline and task, and how to read the bars.",
          },
          trendForecast: {
            summary:
              "How booked hours build up week by week, the recent pace and forecast, the breakdown by discipline and how the legend works.",
          },
          myProjects: {
            title: "My projects",
            summary:
              "The projects you booked hours on: your hours per client and project, your productivity and quick links to the project folder and Teams.",
            intro:
              "My projects shows every project you booked hours on in the selected period. At the top are three cards summarising your projects, hours and productivity; below them is a table of your clients and their projects.",
            notManaged:
              "Note: these are the projects you booked hours on yourself, not the projects you manage or lead. If you did not book on a project in the selected period, it is not listed.",
            toolbar: {
              title: "At the top of the page",
              period:
                "choose which period you want to see. Pick a shortcut (current week, previous week, this month, last month or year to date), or select your own start and end date in the calendar and click Apply. The default is ‘Year to date’.",
              user: "view the same page for a colleague. You only see this option as an admin or timesheet admin.",
            },
            cards: {
              intro: "The three cards summarise the selected period:",
              sketchAlt: "Example of the {card} card",
              projects:
                "how many projects you booked on, split into billable projects (for a client) and internal projects. The large number is the total; the bar below it shows the split.",
              hours:
                "how many hours you booked and where they went. Use the Clients / Projects button at the top right of the card to switch between a breakdown per client and per project. The number in the middle is the total number of hours.",
              productivity:
                "the share of your hours that went to client projects: hours on client projects divided by hours on client projects plus hours on internal projects. The department project, on which you book department tasks, is also an internal project. Leave and sick leave (HR tasks) do not count.",
              productivityExample:
                "Example: 30 hours on client projects, 10 hours of department tasks and 8 hours of leave gives 30 ÷ (30 + 10) = 75%. So department tasks do lower your productivity, leave does not.",
            },
            legend: {
              title: "The legend below the Hours and Productivity donuts",
              click: {
                label: "Click an item",
                text: "to hide that part of the donut. The rest of the donut is then spread over the whole ring, so you can see the remaining proportions better.",
              },
              restore: {
                label: "Show it again",
                text: "click the faded item once more.",
              },
              center: "The number in the middle of the donut stays the total of everything, even when you hide items.",
              noDoubleClick:
                "Unlike the trend chart on the project detail page, double-clicking has no special function here: in the donuts you show or hide items one at a time.",
            },
            table: {
              intro: "The table lists your clients, with the projects you booked on for each client.",
              expand: "Click anywhere on a client row to expand or collapse that client's projects.",
              columns: "For each project you see:",
              columnNumberName: "the project number and project name;",
              columnStatus: "the status. Active projects are at the top, inactive ones below;",
              columnBilling:
                "the billing method: Time & material (your hours are invoiced) or Fixed price (a fixed price was agreed);",
              columnBudget:
                "the hours budget: how much of the budgeted hours has been used. Green is within budget, red is over it.",
              paging:
                "At the bottom of the table you choose how many clients you see per page (5, 10 or 20) and move to the next page.",
            },
            actions: {
              title: "Quick actions",
              clientRow: "On a client row:",
              projectRow: "On a project row:",
              website: "open the client's website.",
              address: "open the client's address in Google Maps.",
              folder:
                "show the path to the project folder. Copy it and paste it into the address bar of File Explorer to open the folder.",
              teams: "open the project's Teams team. It searches for a team with the project number in its name.",
              detail: "open the project details, with the hours budget per discipline and the trend & forecast. Help:",
            },
            tip1: "Check last week's hours with the ‘Previous week’ shortcut before you submit them.",
            tip2: "Switch between Clients and Projects on the Hours card to see where your time goes.",
            tip3: "The folder icon on a project row gets you to the project folder faster than searching in File Explorer.",
            tip4: "Hide your largest client in the legend of the Hours card to see the split across the rest more clearly.",
            faq: {
              q1: "Why don't I see a project?",
              a1: "You only see projects you booked hours on yourself in the selected period. Choose a longer period, for example ‘Year to date’ or a custom range. Hours from before 2025 are not loaded on this page.",
              q2: "Why doesn't my leave count towards my productivity?",
              a2: "Leave and sick leave (tasks starting with HR-) do not count at all: not as productive and not in the total. That way your productivity does not drop while you are on holiday. Department tasks do count in the total and lower your productivity.",
              q3: "What is the difference between billable and internal?",
              a3: "A billable (external) project is a project for a client. An internal project is a Vicoma project, such as the department project on which you book department tasks and leave.",
              q4: "Why don't I see an hours budget or a button to the project details?",
              a4: "The hours budget and the project details are only available to admins. If you need them for your work, request access via Topdesk.",
              q5: "The Teams button says ‘No Teams found for this project’. What now?",
              a5: "The button searches for a team whose name contains the project number. If the project has no team yet, or the number is not in its name, nothing is found. Look up the team yourself in Teams instead.",
              q6: "Do hours I haven't submitted yet count too?",
              a6: "Yes. The page counts all your hour entries in the period, including drafts and entries that have not been approved yet. The total can therefore be higher than what has already been approved.",
            },
          },
          login: {
            title: "Signing in",
            summary: "Signing in with your Vicoma Microsoft account.",
            blocks: [
              {
                type: "p",
                text: "You sign in with your Vicoma Microsoft account, the same account you use for Outlook and Teams. There is no separate password for this app.",
              },
              {
                type: "steps",
                items: [
                  "Open the app and click Sign in.",
                  "Choose your Vicoma account, or enter your Vicoma email address and password.",
                  "Complete the extra verification (MFA) if Microsoft asks for it.",
                ],
              },
              {
                type: "tip",
                text: "You stay signed in until you sign out or Microsoft asks you to sign in again. You sign out via your profile picture at the top right.",
              },
            ],
          },
          loginTrouble: {
            title: "Trouble signing in",
            summary: "What to do when signing in does not work.",
            blocks: [
              { type: "p", text: "Can't sign in? Go through these steps:" },
              {
                type: "steps",
                items: [
                  "Check your internet connection.",
                  "Use your Vicoma email address; it ends in {'@'}vicoma.nl.",
                  "Check your password by signing in at office.com. If that fails too, the problem is your account, not this app.",
                  "Try a private window, or clear your browser's cache and cookies.",
                ],
              },
              {
                type: "tip",
                text: "Still not working? Create a ticket in Topdesk and mention the error message you see.",
              },
            ],
          },
          installApp: {
            title: "Installing the app",
            summary: "Putting Vicoma People on your computer or phone as an app.",
            blocks: [
              {
                type: "p",
                text: "You can install Vicoma People as an app. It then opens in its own window without an address bar, and you can find it in your start menu or on your phone's home screen.",
              },
              {
                type: "steps",
                items: [
                  "Do you see the Install button with a red dot in the menu on the left, under Help & support? Click it and confirm.",
                  "Don't see that button? Use the install icon in the address bar of Chrome or Edge. On an iPhone or iPad, choose Share → Add to Home Screen in Safari.",
                ],
              },
              {
                type: "tip",
                text: "If the app is already installed, or your browser does not support installing, the Install button does not appear.",
              },
            ],
          },
          updateApp: {
            title: "Updating the app",
            summary: "What the ‘New version available’ message means.",
            blocks: [
              {
                type: "p",
                text: "When a new version of the app is available, you see the message ‘New version available’. You decide when to update:",
              },
              {
                type: "list",
                items: [
                  "Reload: the app refreshes straight away and you work with the latest version.",
                  "Later: you keep working in the current version. The message comes back when you open the app again.",
                ],
              },
              {
                type: "p",
                text: "After an update, the ‘What's new’ overview shows the changes in the new version.",
              },
            ],
          },
          findColleague: {
            title: "Finding a colleague",
            summary: "Searching, filtering and sorting in the people directory.",
            blocks: [
              { type: "p", text: "The start page (People) lists all your colleagues." },
              {
                type: "list",
                items: [
                  "Type in the search field. It searches all of a colleague's details, such as name, job title, department, office and skills.",
                  "Click a department or skill on a card to search for that department or skill straight away.",
                  "Under ‘Sort by’, choose first name, last name, department, email, office or job title. The arrow next to it reverses the order.",
                ],
              },
              {
                type: "tip",
                text: "New colleagues who joined this month have a ‘New colleague’ ribbon.",
              },
            ],
          },
          profileCard: {
            title: "A colleague's profile",
            summary: "What you see and can do on a colleague's card.",
            blocks: [
              { type: "p", text: "On a colleague's card you see, among other things:" },
              {
                type: "list",
                items: [
                  "name, job title and department;",
                  "office and contact details;",
                  "skills and expertise.",
                ],
              },
              { type: "p", text: "What you can do:" },
              {
                type: "list",
                items: [
                  "Click the email address to send an email.",
                  "Click the phone number to call (on your phone or with a softphone).",
                  "Click the profile picture for a larger photo.",
                  "Click the department or a skill to find colleagues with the same department or skill.",
                ],
              },
            ],
          },
          registerHours: {
            title: "Registering hours",
            summary: "Where you book hours and where you see them in the app.",
            blocks: [
              {
                type: "p",
                text: "You register hours in Dynamics 365. This app only reads your hours: you cannot book or change anything here.",
              },
              { type: "h", text: "Where do you see your hours?" },
              {
                type: "list",
                items: [
                  "Timesheet (menu on the left): all your hour entries per year, with filters for the current week and for leave, and an export to Excel.",
                  "My projects: your hours per client and per project, and your productivity.",
                ],
              },
              { type: "h", text: "Columns and filters in the Timesheet" },
              {
                type: "p",
                text: "On the right side of the Timesheet table there are two tabs: Filters and Columns.",
              },
              {
                type: "list",
                items: [
                  "Filters: filter on, for example, a project, task or status. Click the tab again to close the panel.",
                  "Columns: tick a column to add it to the table, such as Description, Work location (office, at the customer or at home), Customer or Hour code. Untick it to remove it again.",
                  "After changing the columns, the table is collapsed again. Use 'Expand all' to see every row.",
                ],
              },
              {
                type: "tip",
                text: "The day columns (Mon to Sun) and the tab names follow the language you choose in the app.",
              },
              {
                type: "tip",
                text: "Just changed something in Dynamics? Refresh the page to see your latest hours.",
              },
            ],
          },
          productivity: {
            title: "How is productivity calculated?",
            summary: "Which hours count and which don't, with an example.",
            blocks: [
              {
                type: "p",
                text: "Productivity is the share of your hours that goes to client projects.",
              },
              {
                type: "list",
                items: [
                  "Productive: hours on client projects (billable, external projects).",
                  "Total: hours on client projects plus hours on internal projects. The department project, on which you book department tasks, is also an internal project.",
                  "Leave and sick leave (tasks starting with HR-) do not count at all.",
                ],
              },
              {
                type: "p",
                text: "Productivity = hours on client projects ÷ (hours on client projects + hours on internal projects) × 100%.",
              },
              {
                type: "tip",
                text: "Example: 30 hours on client projects, 10 hours of department tasks and 8 hours of leave gives 30 ÷ (30 + 10) = 75%. So department tasks do lower your productivity, leave does not.",
              },
              {
                type: "p",
                text: "You can see your own productivity on the My projects page.",
              },
            ],
          },
          incompleteTimesheets: {
            title: "Incomplete timesheets",
            summary: "For admins: seeing whose timesheet is not complete yet and sending a reminder.",
            blocks: [
              {
                type: "p",
                text: "This page gives admins and timesheet admins a weekly overview of every employee's timesheet: who is complete, who is not, and why not.",
              },
              { type: "h", text: "Filters" },
              {
                type: "list",
                items: [
                  "Week: choose the week you want to see.",
                  "Status: only show employees with a certain status.",
                  "Office and Department: limit the overview to an office or department.",
                  "Search by name: find an employee quickly.",
                ],
              },
              { type: "h", text: "Statuses" },
              {
                type: "list",
                items: [
                  "No hours: the employee has not submitted anything for this week yet.",
                  "Too few hours: less was submitted than the weekly norm.",
                  "More hours: more was submitted than the weekly norm.",
                  "Returned hours: hours were rejected and need to be submitted again.",
                  "Recall requested: a request was made to withdraw submitted hours.",
                  "Not yet approved: the hours were submitted but not approved yet.",
                  "Complete: the timesheet meets the weekly norm.",
                ],
              },
              {
                type: "p",
                text: "A ‘Draft’ chip means the employee has hours in draft that have not been submitted yet.",
              },
              { type: "h", text: "Sending a reminder" },
              {
                type: "steps",
                items: [
                  "Click the envelope icon next to the employee.",
                  "Your email program opens with a pre-filled reminder, with a subject and text that match the status (for example how many hours are still missing).",
                  "Check the email and send it yourself.",
                ],
              },
              {
                type: "warning",
                text: "Nothing is sent automatically: the email only goes out when you click send.",
              },
            ],
          },
          skills: {
            title: "Updating your skills",
            summary: "Adding skills to your profile so colleagues can find you.",
            blocks: [
              {
                type: "p",
                text: "Your skills come from your Microsoft 365 profile. This is how you update them:",
              },
              {
                type: "steps",
                items: [
                  "Click your avatar at the top right.",
                  "Choose ‘Edit profile’.",
                  "Click ‘Update your profile’.",
                  "Click ‘Info’.",
                  "Add new skills or change existing ones.",
                ],
              },
              {
                type: "tip",
                text: "No skills yet? Then your own card has an ‘Add some skills to your profile!’ button that takes you straight to your profile. New skills show up in the app after a while.",
              },
            ],
          },
          compass: {
            title: "Compass: finding comparable projects",
            summary: "Find earlier comparable scopes of work and the man-hours quoted for them.",
            blocks: [
              {
                type: "p",
                text: "Compass searches earlier scopes of work for projects that resemble a new request, and shows the man-hours from the hours specifications. Only members of the Compass group see this page.",
              },
              {
                type: "warning",
                text: "Compass runs on our own network. It only works at the office or via VPN. Client data never leaves our network.",
              },
              { type: "h", text: "Searching" },
              {
                type: "steps",
                items: [
                  "Describe the scope of the new request in your own words (at least 20 characters).",
                  "Optionally narrow down by discipline, client, years and size in hours.",
                  "Click Search. Each card shows a comparable project with its similarity, man-hours per role and software hours.",
                ],
              },
              { type: "h", text: "Hours indication" },
              {
                type: "p",
                text: "From 2 projects with hours, Compass shows the minimum, median and maximum per role and in total. Untick a card to leave a project out; the indication is recalculated immediately. These numbers are calculated directly from the hours specifications, never by the language model.",
              },
              {
                type: "list",
                items: [
                  "'Shared hours specification': the hours for this project are in one specification for several items and cannot be allocated, so the project does not count.",
                  "'Does not count': Compass marks this project as unsuitable for the indication, for example because of an older revision.",
                ],
              },
              { type: "h", text: "AI comparison and feedback" },
              {
                type: "p",
                text: "'Compare with AI' describes the similarities and differences between your request and the ticked projects, with advice. Rate each result with Good, Fair or Wrong: that helps improve Compass.",
              },
              {
                type: "tip",
                text: "On the VPN and still the message 'only available at the office or via VPN'? Your browser may be asking for permission to access devices on your local network. Allow it and click Try again.",
              },
            ],
          },
          offline: {
            title: "Using the app offline",
            summary: "What does and doesn't work without an internet connection.",
            blocks: [
              { type: "p", text: "The app works in a limited way without an internet connection:" },
              {
                type: "list",
                items: [
                  "You can view data and photos you loaded earlier.",
                  "New data is only loaded once you are connected again.",
                ],
              },
              {
                type: "tip",
                text: "Most features need an active internet connection.",
              },
            ],
          },
          language: {
            title: "Changing the language",
            summary: "Switching between Dutch and English.",
            blocks: [
              {
                type: "steps",
                items: [
                  "Click NL or EN at the top right.",
                  "The language changes straight away and is remembered for next time.",
                ],
              },
              { type: "p", text: "Available languages: Dutch and English." },
            ],
          },
        },
      },
      projectAdmin: {
        title: "Statistics",
        incompleteTimesheetCardTitle: "Timesheets",
        allUsersCompliant: "All users meet their weekly hours",
        allUsersCompliantDescription: "No action required this week.",
        shortage: "Shortage: {hours}h",
        sendReminder: "Send reminder email",
        statusHeaders: {
          incomplete: "Incomplete",
          complete: "Complete",
          other: "Other",
        },
        status: {
          insufficientHours: "Insufficient hours",
          returned: "Returned hours",
          recallRequested: "Recall requested",
          noEntries: "No entries",
          complete: "Complete",
          fullyApproved: "Fully approved",
          notYetApproved: "Not yet approved",
          excessHours: "Excess hours",
          all: "All",
        },
        filters: {
          office: "Office",
          department: "Department",
          status: "Status",
          selectWeek: "Select week",
          searchPlaceholder: "Search by name",
        },
        chips: {
          noHours: "No hours",
        },
        stats: {
          incompleteTimesheets: "Incomplete timesheets",
          percentComplete: "Percentage of timesheets complete",
          totalShortage: "Total shortage",
          avgProductivity: "Average productivity",
          weightedAvg: "Weighted average",
          simpleAvg: "Simple average",
          vsLastWeek: "vs. last week",
          howCalculated: "How is this calculated?",
          weightedExplanation:
            "The weighted average calculates productivity by dividing all billable hours by all relevant hours (excluding HR hours like vacation and sick leave). This provides a more accurate picture of total productivity than a simple average.",
          formula: "Formula",
          weightedBenefit:
            "Benefit: employees with more hours have more influence on the final number, which better reflects the company's actual productivity.",
        },
        billability: "Productivity",
        productivity: "Productivity",
        empty: {
          noResultsTitle: "No results",
          noResultsDescription: "No employees found with the current filters.",
          resetFilters: "Reset filters",
        },
        weekstate: {
          title: "Timesheet",
          normLabel: "Norm",
          noHoursSubmitted: "No hours submitted",
          selectUserHint:
            "Select an employee on the left to view the timesheet.",
        },
        email: {
          subject: "Reminder: Timesheet week {week}, {year}",
          greeting: "Dear {name},",
          noEntries:
            "You have not yet submitted any hours for week {week}, {year}.\nYour norm is {contractHours} hours.",
          insufficientHours:
            "You have submitted {totalHours} hours for week {week}, {year}.\nThe norm is {contractHours} hours.\nYou are still missing {shortage} hours.",
          returned:
            "You have {returnedHours} returned hours in week {week}, {year}.\nPlease resubmit these hours.",
          recall:
            "There is a recall request for {recallHours} hours in week {week}, {year}.\nPlease review these hours.",
          closing: "Please complete your timesheet as soon as possible.",
          signature: "Kind regards,\nThe Project Administration Team",
        },
      },
      refreshData: "Refresh data",
      dataFetchedAt: "Data from {time}",
      close: "Close",
      feedback: {
        pageTitle: "Feedback",
        intro: "Help us improve the app: vote for the features you want most, or share an idea, bug or compliment. Your feedback is sent with your name so we can follow up.",
        poll: {
          title: "Which features do you want first?",
          subtitle: "Choose up to {max}. You can change your votes at any time.",
          votes: "no votes | 1 vote | {n} votes",
          save: "Save votes",
          saved: "Your votes have been saved",
          saveError: "Could not save your votes. Please try again.",
          loadError: "Could not load the poll. Please try again later.",
          inProgress: "Already in progress",
          status: {
            planned: "Planned",
            done: "Done",
          },
        },
        comment: {
          title: "Share your feedback",
          subtitle: "An idea, something that doesn't work, or something you like.",
          categories: {
            idea: "Idea",
            bug: "Bug",
            praise: "Compliment",
            other: "Other",
          },
          messageLabel: "Your message",
          required: "Please enter a message",
          tooLong: "At most {max} characters",
          sentAs: "Sent as {name}",
          send: "Send",
          sent: "Thank you for your feedback!",
          sendError: "Could not send your feedback. Please try again.",
        },
        prompt: {
          title: "What do you think of the app?",
          text: "We'd like to know what you want to see in Vicoma People. Vote for new features or share an idea, bug or compliment. It only takes a minute.",
          give: "Give feedback",
          later: "Later",
          never: "Don't ask again",
        },
        admin: {
          title: "All feedback",
          exportCsv: "Export CSV",
          date: "Date",
          name: "Name",
          category: "Category",
          message: "Message",
          page: "Page",
          forbidden: "You do not have access to the feedback list. Ask to be added to the feedback admin group (FEEDBACK_ADMIN_GROUP_ID in the API).",
          loadError: "Could not load the feedback.",
        },
      },
      changelog: {
        title: "What's new",
        newVersion: "New version available!",
        types: {
          feature: "New",
          bugfix: "Fix",
          improvement: "Improved",
          breaking: "Breaking",
        },
      },
      aiAnalysis: {
        title: "AI Analysis",
        noData: "No analysis available for this week",
        analyzing: "Analyzing timesheet data...",
        summary: "Summary",
        priority: "Priority",
        actionItems: "Action items",
        projectBreakdown: "Project breakdown",
        leavePrediction: "Leave prediction",
        capacityForecast: "Capacity forecast",
        projectHealth: "Project health",
        patterns: "Patterns",
        anomalies: "Anomalies",
        predictions: "Predictions",
        deviations: "Deviations",
        recommendations: "Recommendations",
        pattern: "Pattern",
        riskLevel: "Risk level",
        currentWeekHours: "Current week hours",
        recommendation: "Recommendation",
        forecast: "Forecast",
        utilization: "Utilization",
        projectDiversity: "Project diversity",
        hours: "Hours",
        trend: "Trend",
        suggestion: "Suggestion",
        customer: "Customer",
        cached: "Cached",
        loading: "Loading...",
      },
      compass: {
        pageTitle: "Compass – comparable projects",
        intro:
          "Describe the scope of a new request. Compass looks for comparable earlier scopes of work and shows the man-hours quoted for them.",
        mockBadge: "Mock mode: fictitious data",
        status: {
          checking: "Connecting to Compass…",
          unreachableTitle: "Compass is not reachable",
          unreachable: "Compass is only available at the office or via VPN.",
          unreachableHint:
            "Connected to the VPN and still seeing this? Your browser may be asking for permission to access devices on your local network: allow it and try again.",
          retry: "Try again",
          noAccessTitle: "No access",
          noAccess: "You do not have access to Compass. Ask IT to add you to the Compass group.",
        },
        form: {
          scope: "Scope of the new request",
          scopePlaceholder:
            "For example: Instrumentation engineering for a new dosing line with approx. 25 transmitters, 6 control valves, DCS I/O changes and loop diagrams.",
          scopeHint: "Describe the work in your own words (at least {min} characters). No special syntax needed.",
          discipline: "Discipline",
          allDisciplines: "All disciplines",
          client: "Client",
          allClients: "All clients",
          yearFrom: "Year from",
          yearTo: "Year to",
          hoursMin: "Size: min. hours",
          hoursMax: "Size: max. hours",
          language: "Language of the scope",
          languageAuto: "Detect automatically",
          languageNl: "Dutch",
          languageEn: "English",
          topN: "Number of results",
          search: "Search",
          reset: "Clear",
        },
        validation: {
          scopeMin: "Enter at least {min} characters",
          yearRange: "'Year to' must not be earlier than 'year from'",
          hoursRange: "Max. hours must not be less than min. hours",
          nonNegative: "Enter 0 or more",
        },
        errors: {
          unreachable: "Compass is not reachable. Check your VPN connection and try again.",
          unauthorized: "Your sign-in for Compass is not valid. Reload the page and try again.",
          forbidden: "You do not have access to Compass.",
          validation: "Compass did not accept the request. Check the fields and try again.",
          expired: "This search has expired. Search again.",
          server: "Something went wrong in Compass. Try again later.",
        },
        results: {
          title: "Comparable projects",
          count: "no results | 1 result | {n} results",
          searchedIn: "Searched in: {discipline}",
          selected: "{n} selected",
          none: "No comparable projects found. Try broader filters or a different description.",
          toggleHint:
            "Use the checkbox on a card to include or exclude a project from the hours indication and the AI comparison.",
        },
        card: {
          item: "Item",
          revision: "Rev.",
          similarity: "Similarity",
          manHours: "Man-hours per role",
          softwareHours: "Software hours",
          hours: "Hours",
          totalMan: "Total man-hours",
          sharedUs: "Shared hours specification, hours not allocated",
          noHours: "No hours available for this project.",
          notCounted: "Does not count",
          notCountedMultidisciplinary: "Multidisciplinary, no hours per discipline: does not count",
          disciplinePart: "Counts with only the hours of the selected discipline: {hours}",
          excluded: "Excluded",
          includeInIndication: "Include in hours indication",
          showDetails: "Show details",
          hideDetails: "Hide details",
          ws: "Scope of work",
          us: "Hours specification",
        },
        feedback: {
          label: "Good match?",
          goed: "Good",
          matig: "Fair",
          fout: "Wrong",
          sent: "Thanks, your feedback has been saved.",
          error: "Feedback could not be sent. Try again.",
          reasonsLabel: "What is wrong? (optional)",
          reasons: {
            wrong_phase: "Wrong phase (e.g. study instead of detail engineering)",
            wrong_kind: "Wrong kind of work (new build, modification, replacement)",
            wrong_size: "Wrong size (much larger or smaller)",
            wrong_discipline: "Wrong discipline",
            wrong_topic: "Different subject or installation",
            too_old: "Too old or outdated",
            other: "Other",
          },
          noteLabel: "Explanation (optional)",
          noteHint: "Used to improve Compass. Stays within Vicoma.",
          noteTooLong: "Maximum 1000 characters",
          saveDetails: "Save reason",
        },
        indication: {
          title: "Hours indication",
          subtitle: "Calculated from the hours specifications of the selected projects.",
          tooFew:
            "An indication needs at least {min} projects with hours. Currently included: {count}.",
          role: "Role",
          min: "Min",
          median: "Median",
          max: "Max",
          basis: "Based on",
          nOfTotal: "{count} of {total}",
          manSection: "Man-hours",
          softwareSection: "Software hours",
          totalRow: "Total man-hours",
          basisHint:
            "Per role, only projects that have that role count. 'Based on' shows how many of the included projects that is.",
          included: "Included projects",
          disclaimer:
            "This is an indication based on earlier quotes, not an estimate. Always check the scope differences.",
        },
        compare: {
          title: "AI comparison",
          subtitle: "Similarities, differences and advice for the {count} selected project(s).",
          button: "Compare with AI",
          stop: "Stop",
          disclaimer:
            "Generated by a language model on the Compass server itself. The hours indication remains leading for numbers.",
        },
      },
      projectIntake: {
        pageTitle: "Project intake",
        projectTitle: "Project title",
        projectManager: "Project manager",
        customer: "Customer",
        contractingUnit: "Contracting unit",
        billingMethod: "Billing method",
        billingTimeAndMaterial: "Time and material",
        billingFixedPrice: "Fixed price",
        estStartDate: "Estimated start date",
        estDuration: "Estimated duration (months)",
        estimatedRevenue: "Estimated revenue",
        progress: "Progress",
        probability: "Probability",
        teamMembers: "Team members",
        quoteExpSentDate: "Quote expected sent date",
        projectTemplate: "Project template",
        submit: "Submit",
        submitSuccess: "Project intake submitted successfully!",
        submitSuccessTitle: "Submission received",
        submitSuccessMessage:
          "Dynamics 365 will now proceed with creating the Opportunity, Quote, and Project using the data you have entered. The Project will also be linked to the Quote Line. Once this process is complete, you will receive a confirmation by email. Please do not make any changes in Dynamics 365 to the newly created records during this process.",
        submitError: "Failed to submit project intake. Please try again.",
        loadError: "Failed to load form data. Please refresh the page.",
        validation: {
          required: "This field is required",
          maxLength: "Maximum {max} characters",
          positiveInteger: "Must be a positive whole number",
          positiveNumber: "Must be a positive number",
        },
      },
      outlookSignature: {
        title: "Outlook signature",
        copyToClipboard: "Copy signature to clipboard",
        copyError: "Failed to copy signature",
        copied: "Signature copied to clipboard!",
        downloadScript: "Download PowerShell script",
        downloaded: "PowerShell script downloaded!",
        downloadError: "Failed to download script",
        loading: "Loading...",
        error: "Failed to load signature data",
        preview: "Preview",
        userInfo: "Your information",
        fullName: "Full name",
        jobTitle: "Job title",
        email: "E-mail",
        officePhone: "Office phone",
        mobilePhone: "Mobile phone",
        address: "Office address",
        greeting: "Kind regards,",
      },
      admin: {
        documentation: {
          title: "Admin Documentation",
          permissionsTitle: "Permissions & Access Control",
          roles: "Roles",
          routeProtection: "Route Protection",
          routeProtectionInfo:
            "Routes can be protected using route meta configuration. Different protection levels ensure only authorized users can access sensitive features.",
          knownIssues: "Known Issues",
          fullDocRef: "Full Documentation",
          fullDocRefDesc:
            "For comprehensive documentation on the permissions system, refer to the file below:",
          location: "File location",
          example: "Example route protection",
          availableMeta: "Available meta fields",
          envVar: "Environment Variable",
          azureGroup: "Azure group",
          note: "Note",
          permissions: "Permissions",
          grantAccess: {
            title: "Granting someone access",
            step1: "Open the Microsoft Entra admin center (entra.microsoft.com) → Groups → All groups.",
            step2: 'Search for the group of the desired role (see "Azure group" on the role below).',
            step3: "Open Members → Add members → select the user → Select.",
            step4: "The user reloads Vicoma People (F5); the permissions apply immediately.",
            note: "Requires ownership of the group or the Entra role Groups Administrator.",
          },
          role: {
            admin: "Admin",
            adminSubtitle: "Full system access",
            timesheetAdmin: "Timesheet Admin",
            timesheetAdminSubtitle: "Timesheet and analytics access",
            projectIntake: "Project Intake",
            projectIntakeSubtitle: "Project management access",
            compass: "Compass",
            compassSubtitle: "Comparable projects and hours (local RAG)",
            compassNote:
              "No admin exception: full admins without this group do not see Compass either. The Compass API performs the same group check server-side.",
            tester: "Tester",
            testerSubtitle: "Access to in-development features",
            testerNote:
              'This role does not gate any route — it only reveals the "Hour budget" column in the Projects detail grid. Admins see this column too, regardless of tester membership.',
            timesheetAdminNote:
              "The SI Management and SI Dev Admin groups also grant this role via OR logic — members of either group are treated the same as Timesheet Admin.",
            timesheetAdminGroupHint:
              "To grant access, add the user to azg-app-people-timesheet-admin. The SI groups are existing role groups that grant it as well.",
            projectIntakeGroupNote:
              "This is a Dynamics 365 role group: membership also grants the corresponding Dynamics security role.",
          },
          perm: {
            fullAccess: "Full access to all features",
            userSelection: "User selection and cross-user data viewing",
            adminRoutes: "Access to admin-only routes",
            documentationAccess: "Access to admin documentation",
            timesheetAnalytics: "Timesheet analytics and reports",
            incompleteSheetsAccess:
              "Access to incomplete timesheets management",
            projectManagement: "Project administration features",
            projectIntakeAccess: "Access to project intake routes",
            compassAccess: "Access to the Compass page (/compass); only works at the office or via VPN",
            budgetColumnAccess:
              'Visibility of the "Hour budget" column in the Projects detail grid',
          },
          meta: {
            requiresAdmin: "Admin or Timesheet Admin access required",
            requiresFullAdmin:
              "Full Admin access only (highest permission level)",
            requiresProjectIntake: "Project Intake or Admin access required",
            requiresCompass: "Compass group only (no admin exception)",
          },
          issue: {
            siGroups: "SI Management & SI Dev Admin Groups",
            siGroupsDescription:
              "The SI Management and SI Dev Admin groups currently grant Timesheet Admin permissions via OR logic. Verify if this is intentional.",
            leaveAdmin: "Leave Admin Not Implemented",
            leaveAdminDescription:
              "The Leave Admin role is currently not implemented and always returns false. If needed in the future, implementation requires configuration and route setup.",
          },
        },
      },
      dashboard: {
        title: "Admin Dashboard - Productivity & Metrics",
        year: "Year",
        office: "Office",
        allOffices: "All",
        refresh: "Refresh data",
        hoursSuffix: "h",
        whatCounts: "What counts:",
        productivity: {
          title: "Average Productivity",
          infoTitle: "How is productivity calculated?",
          infoText:
            "Average productivity on the dashboard is company-wide: the percentage of billable hours out of total hours worked excluding leave hours, rounded to whole percentages.",
          calculation: "Calculation:",
          infoFooter:
            "This reflects the productivity of the company as a whole, not of individual employees.",
          subtitle: "{year} ({billable} of {total} hours)",
        },
        totalHours: {
          title: "Total Hours",
          subtitle: "Of which {billable} billable",
        },
        projects: {
          title: "Projects",
          infoTitle: "Active Projects",
          infoText:
            "This number shows the count of unique projects with time registered in the selected year.",
          counts1: "All projects with at least 1 hour registered",
          counts2: "Filtered by selected office (if applicable)",
          counts3: "Billable projects only",
          infoFooter:
            "This KPI gives insight into the diversity and spread of project work across the organisation.",
        },
        employees: {
          title: "Employees",
          infoTitle: "Active Employees",
          infoText:
            "This number shows the count of unique employees who registered time in the selected year.",
          counts1: "Employees with at least 1 registered hour",
          counts2: "Including leave and non-billable hours",
          counts3: "Filtered by selected office (if applicable)",
          infoFooter:
            "This KPI gives insight into the size of the active workforce.",
          subtitle: "With hours in {year}",
        },
        chart: {
          title: "Weekly Productivity & Hours Breakdown - {year}",
          noData: "No data available for the selected year",
          week: "Week {week}",
          billable: "Billable",
          nonBillable: "Non-billable",
          leave: "Leave",
          total: "Total",
          employees: "Employees",
          billableSeries: "Billable (h)",
          nonBillableSeries: "Non-billable (h)",
          leaveSeries: "Leave (h)",
          productivityYear: "Productivity {year}",
          productivity: "Productivity",
          totalHours: "Total hours",
          weekNumber: "Week number",
          hoursPerWeek: "Hours per week",
          productivityAxis: "Productivity (%)",
          target: "Target (80%)",
        },
      },
    },
    nl: {
      nav: {
        people: "People",
        organogram: "Organigram",
        timesheet: "Timesheet",
        leave: "Verlof",
        projects: "Projecten",
        projectAdmin: "Project administratie",
        dashboard: "Dashboard",
        incompleteTimeEntries: "Timesheets",
        projectIntake: "Project intake",
        compass: "Compass",
        myProjects: "Mijn projecten",
        adminDocumentation: "Admin documentatie",
        help: "Help",
        outlookSignature: "E-mailhandtekening",
        helpSupport: "Help & Support",
        feedback: "Feedback",
        installApp: "Installeren",
      },
      appBarAvatarCard: {
        editProfile: "Wijzig profiel",
        logOut: "Uitloggen",
      },
      avatarCard: {
        addSkillsButton: "Voeg skills toe aan je profiel!",
      },
      people: {
        search: "Zoek",
        newEmployeeRibbon: "Nieuwe collega",
        newEmployeesModal: {
          title: "Welkom nieuwe collega's!",
        },
        sort: {
          label: "Sorteren op",
          toggleSortOrderTip: "Sorteer volgorde omdraaien",
          options: {
            givenName: "Voornaam",
            surname: "Achternaam",
            department: "Afdeling",
            mail: "E-mail",
            officeLocation: "Vestiging",
            jobTitle: "Functietitel",
          },
        },
      },
      organogram: {
        appBarTitle: "Organigram",
        selectDepartment: "Selecteer afdeling",
        selectOffice: "Selecteer kantoor",
      },
      timesheet: {
        exportToExcel: "Exporteren naar Excel",
        filterCurrentWeekButton: "Filter op huidige week",
        filterLeaveButton: "Filter verlof",
        expandAllButton: "Alles uitklappen",
        collapseAllButton: "Alles inklappen",
        selectYear: "Jaar",
        selectUser: "Gebruiker",
        sidebar: {
          filters: "Filters",
          columns: "Kolommen",
        },
        workLocation: {
          office: "Kantoor Vicoma",
          onsite: "Bij klant",
          home: "Thuis",
        },
        gridTips: {
          title: "Nieuw: kolommen en filters",
          intro:
            "Rechts naast de tabel vind je twee tabbladen: Filters en Kolommen. Daarmee bepaal je zelf wat je ziet.",
          filters: {
            title: "Filters",
            text: "Open het tabblad Filters en filter bijvoorbeeld op een project, taak of status. Klik nogmaals op het tabblad om het paneel te sluiten.",
          },
          columns: {
            title: "Kolommen",
            text: "Vink in het tabblad Kolommen een kolom aan om die aan de tabel toe te voegen, zoals Description, Work location, Customer of Hour code. Vink hem uit om hem weer weg te halen.",
          },
          expand: {
            title: "Alles uitklappen",
            text: "Na het toevoegen of weghalen van een kolom wordt de tabel opnieuw opgebouwd en ingeklapt. Gebruik 'Alles uitklappen' om weer alle regels te zien.",
          },
          helpHint:
            "Je ziet dit bericht één keer. Je kunt het teruglezen onder Help > Uren registreren.",
          gotIt: "Begrepen",
        },
        grid: {
          noUserFound: "Geen gebruiker gevonden",
          errorLoadingMessage: "Laden van gebruikersgegevens mislukt",
          loadingMessage: "Data laden van",
          holidayWarning:
            'Waarschuwing: Feestdag - Gebruik taak "HR-Feestdag(en) / Public holidays"',
        },
        hours: "u",
        tooLittle: "te weinig",
        headers: {
          date: "Datum",
          project: "Project",
          task: "Taak",
          description: "Beschrijving",
          status: "Status",
        },
      },
      leave: {
        totalLeaveHeader: "Verlof saldo",
        daysLeft: "dagen resterend",
        hours: "uur",
        days: "dagen",
        remaining: "resterend",
        short: "te kort",
        hoursUsedThisYear: "uur opgenomen",
        hoursPaidOut: "uur uitbetaald / transfer",
        hoursCorrected: "correctie",
        hoursExpired: "uur vervallen",
        totalLeaveHours: "Begin saldo",
        overtimeSpared: "TvT overuren opgespaard",
        includeFeatureLeave: "Toekomst tonen",
        annualLeave: "Verlof",
        overtime: "Tijd voor tijd",
        tvtSpared: "TvT opgebouwd",
        termsOfEmployment: "Arbeidsvoorwaardenregeling",
        tooltipLeaveTotal: `Het totale verlof bestaat uit: (boven) wettelijk, leef/diensttijd verlof, ADV en TvT uren. { lineBreak}
        Voor meer informatie kun je de { termsPage } hoofdstuk 5 paragraaf 1 raadplegen.`,
        tooltipLeaveStatutory: `Het verlof in deze balk bestaat uit het (boven) wettelijk, leef/diensttijd verlof. { lineBreak }
        Voor meer informatie kun je de { termsPage } hoofdstuk 5 paragraaf 1 raadplegen.`,
        tooltipLeaveAdv: `Voor meer informatie kun je de { termsPage } hoofdstuk 6 raadplegen.`,
        tooltipTvt: `Voor meer informatie kun je de { termsPage } hoofdstuk 11 raadplegen.`,
        nextUser: "Volgende gebruiker",
        hr2dayForbidden: "Verlofsaldo van andere medewerkers is alleen beschikbaar voor full admins.",
        hr2dayEmployeeNotFound: "Geen personeelsnummer gevonden voor deze gebruiker in Entra ID.",
        hr2dayUnavailable: "Verlofsaldo uit HR2Day kon niet worden geladen.",
        hr2dayEntraUnavailable: "Medewerkergegevens konden niet uit Entra ID worden opgehaald, waardoor het verlofsaldo niet kon worden geladen.",
      },
      projects: {
        pageTitle: "Projecten",
        internal: "Intern",
        external: "Factureerbaar",
        projectCardDescription: "Interne & externe projecten",
        projectCardTooltip:
          "Toont het aantal projecten waarop in de geselecteerde periode is geboekt, opgesplitst in interne en factureerbare (externe) projecten.",
        hoursCardDescription: "Geschreven uren per project",
        hoursCardTooltip:
          "Toont het totaal aantal geboekte uren in de geselecteerde periode, per klant of per project (wissel met Klanten / Projecten). Het getal in het midden is het totaal.",
        hoursCardTitle: "Uren",
        hoursCardViewClients: "Klanten",
        hoursCardViewProjects: "Projecten",
        productivityCardDescription: "Productieve vs. non-productieve uren",
        productivityCardTitle: "Productiviteit",
        productivityCardTooltip:
          "Uren op klantprojecten gedeeld door uren op klantprojecten plus uren op interne projecten (inclusief afdelingstaken op het afdelingsproject), afgerond op hele procenten. Verlof en ziekte (HR-taken) tellen niet mee. Voorbeeld: 30 u klantprojecten, 10 u afdelingstaken, 8 u verlof = 75%.",
        projectCounter: {
          unit: "project | projecten",
          empty: "Geen projecten in deze periode",
        },
        chartCenter: {
          totalHours: "Totaal uren",
          average: "Gemiddeld",
        },
        hours: "Uren",
        billableHours: "Productiviteit",
        dateRange: {
          label: "Periode",
          apply: "Toepassen",
          cancel: "Annuleren",
          currentWeek: "Huidige week",
          previousWeek: "Vorige week",
          thisMonth: "Deze maand",
          lastMonth: "Vorige maand",
          yearToDate: "Jaar tot nu",
        },
        grid: {
          client: "Klant",
          telephone: "Telefoon",
          actions: "Acties",
          projectNumber: "Project nummer",
          projectName: "Project naam",
          active: "Actief",
          inactive: "Inactief",
          hoursBudget: "Urenbudget",
          billingMethod: "Facturatiemethode",
          timeAndMaterial: "Regie",
          fixedPrice: "Vaste prijs",
          loadingMessage: "Data laden...",
          noRowsMessage: "Geen projecten gevonden voor deze periode",
          errorLoadingMessage: "Fout bij het laden van gegevens",
          noUserFound: "Geen gebruiker gevonden",
        },
        budget: {
          noBudget: "Geen budget",
          hoursShort: "u",
        },
        hoursStatus: {
          title: "Urenbudget",
          unknown: "Onbekend",
          noData: "Geen geboekte uren gevonden voor dit project",
          error: "Kon uren per afdeling niet laden",
          columnTask: "Taak",
          columnProgress: "Voortgang",
          columnHours: "Uren",
          expandAll: "Alles uitklappen",
          collapseAll: "Alles inklappen",
        },
        progressOverTime: {
          title: "Trend & prognose",
          noData: "Geen geboekte uren gevonden voor dit project",
          error: "Kon voortgang over tijd niet laden",
          seriesBooked: "Geboekte uren",
          seriesCumulative: "Cumulatief",
          seriesProjected: "Projectie",
          seriesPercentOfBudget: "% van budget",
          budgetLine: "Budget: {hours} u",
          budgetLinePercent: "Budget (100%)",
          viewTotal: "Totaal",
          viewDiscipline: "Per discipline",
          viewDisciplineTooltip:
            "Per discipline tonen de staven de geboekte uren per week (gestapeld). De lijnen tonen het cumulatief als % van het eigen budget van de discipline, zodat disciplines met verschillende budgetten vergelijkbaar zijn. De gestippelde lijn is de prognose op het recente tempo van die discipline. Klik op een discipline in de legenda om die aan of uit te zetten.",
          viewDisciplineUnavailable:
            "De uitsplitsing per discipline is beschikbaar als er op meer dan één discipline uren geboekt of begroot zijn.",
          noDiscipline: "Zonder discipline",
          otherDisciplines: "Overig ({count})",
          noBudget: "geen budget",
          table: {
            discipline: "Discipline",
            budget: "Budget",
            booked: "Geboekt",
            percent: "% budget",
            recentPace: "Recent tempo",
            endDate: "Verwacht einde",
          },
          kpi: {
            remainingBudget: "Resterend budget",
            recentPace: "Recent tempo",
            recentPaceTooltip:
              "Gewogen gemiddelde van de laatste {weeks} afgeronde weken, waarbij recente weken zwaarder tellen (laatste week ×{weeks}, oudste ×1). Zo volgt het tempo de fase waarin het project zit (opstart, piek of afronding). Weken zonder boekingen tellen mee als 0. De lopende week telt niet mee, omdat uren vaak later worden geboekt. Ter vergelijking staat eronder het gemiddelde over de hele looptijd.",
            lifetimePace: "Gemiddeld over looptijd: {pace}",
            week: "week",
            endDate: "Verwachte einddatum",
            endDateTooltip:
              "Op basis van het recente tempo: wanneer het resterende budget naar verwachting op is, gerekend vanaf vandaag. Zijn er de laatste {weeks} weken geen uren geboekt, dan ligt het project stil en is er geen prognose. Is het budget al bereikt, dan staat hier de week waarin dat gebeurde. Let op: in de afrondingsfase van een project daalt het tempo meestal verder, dus dan is deze datum aan de optimistische kant.",
            activePeriod: "Actieve periode",
            activePeriodTooltip:
              "Aantal kalenderweken van de eerste geboekte urenregel tot en met vorige week, inclusief weken zonder boekingen (ook als het project nu stilligt). Over deze periode wordt het gemiddelde over de looptijd berekend.",
            budgetReached: "Budget bereikt op {date}",
            projectedEnd: "Verwacht op dit tempo: {date}",
            stalled: "Ligt stil sinds {date}",
            unknown: "Onbekend",
            activeWeeks: "{weeks} weken",
          },
        },
        detailHelp: {
          hoursStatus: {
            intro:
              "Hoeveel van het urenbudget van dit project al is gebruikt. Bovenaan staat de balk voor het hele project, daaronder één balk per discipline. Klap een discipline uit om de functies of taken eronder te zien, elk met een eigen balk.",
            readIntro:
              "Elke balk toont het percentage van het budget dat is gebruikt, met rechts de geboekte uren ten opzichte van het budget. De kleur vertelt je in één oogopslag hoe het ervoor staat:",
            examples: {
              withinBudget: "Groen: binnen budget. Hier is 60 van de 100 begrote uren gebruikt.",
              overBudget: "Rood: over budget. Er is meer geboekt dan begroot, dus ook de uren rechts worden rood.",
              bookedWithoutBudget: "Rode volle balk met 'geen budget': er zijn uren geboekt op iets waarvoor geen budget is.",
              noBudget: "Alleen 'geen budget' (grijs): er is geen budget en er zijn nog geen uren geboekt.",
            },
            use1: "Klik op een discipline om de functies of taken eronder open of dicht te klappen.",
            use2: "Met de knop 'Alles uitklappen' / 'Alles inklappen' boven de lijst open of sluit je alle disciplines tegelijk.",
            use3: "Disciplines en taken staan op volgorde van budget, de grootste bovenaan. Beweeg over een afgekapte naam om de volledige naam te zien.",
            faq: {
              q1: "Welke uren tellen als geboekt?",
              a1: "Alle urenregels op het project, ook concepten en uren die nog niet zijn ingediend of goedgekeurd. Alleen geannuleerde en teruggestuurde uren tellen niet mee; een teruggestuurd uur telt weer mee zodra het is gecorrigeerd en opnieuw ingediend. Urenbudget en Trend & prognose gebruiken precies dezelfde uren, dus de totalen komen overeen. De cijfers kunnen licht afwijken van de financiële administratie in Dynamics, die uren pas na goedkeuring meetelt en correcties apart verwerkt.",
              q2: "Waar komt het budget vandaan en hoe pas ik het aan?",
              a2: "Het budget is de som van de begrote uren op de projecttaken in Dynamics. Deze app leest die alleen uit; aanpassen doe je in Dynamics (of vraag het de projectleider). Na een aanpassing zie je het nieuwe budget als je deze pagina opnieuw opent.",
              q3: "Waarom staat er een taak in rood met 'geen budget'?",
              a3: "Op die taak zijn uren geboekt terwijl er geen begrote uren op staan. Dat kan bewust zijn, maar vaak betekent het dat er op de verkeerde taak is geboekt of dat het budget nog niet is ingevuld.",
            },
          },
          progress: {
            intro:
              "Hoe de geboekte uren zich week voor week opbouwen ten opzichte van het budget, en wanneer het budget op dit tempo naar verwachting op is. Bovenaan staan vier tegels:",
            kpi: {
              remainingBudget: "hoeveel uren er nog over zijn van het budget.",
              recentPace:
                "hoeveel uur er de laatste {weeks} weken gemiddeld per week is geboekt, waarbij recente weken zwaarder tellen. Eronder staat ter vergelijking het gemiddelde over de hele looptijd.",
              endDate: "wanneer het resterende budget op het recente tempo op is, of in welke week het budget al werd bereikt.",
              activePeriod: "hoeveel weken er zijn verstreken sinds de eerste boeking, tot en met vorige week.",
            },
            sketchAlt:
              "Schets van de grafiek: blauwe staven per week, een groene cumulatieve lijn, een rode gestippelde budgetlijn en een gestippelde prognoselijn, met genummerde markeringen.",
            chart1: "Blauwe staven: de geboekte uren per week (as links).",
            chart2: "Groene lijn: het cumulatieve totaal, dus alle uren tot en met die week bij elkaar opgeteld (as rechts).",
            chart3: "Rode stippellijn: het budget. Waar de groene lijn deze lijn raakt, is het budget op.",
            chart4: "Gestippelde groene lijn: de prognose. Zo loopt het cumulatief verder als het recente tempo gelijk blijft.",
            chart5: "Weken zonder staaf: er is die week niets geboekt. De grafiek loopt door tot vorige week, zodat je ook ziet als een project nu stilligt.",
            discipline1:
              "Met de knop 'Per discipline' boven de grafiek splits je de uren uit per discipline. Elke discipline heeft een eigen kleur.",
            discipline2:
              "De staven zijn gestapeld: de hele staaf is nog steeds het weektotaal, de kleuren laten zien hoeveel elke discipline heeft geboekt.",
            discipline3:
              "De lijnen tonen per discipline het cumulatief als percentage van het eigen budget. De rode 100%-lijn betekent: budget van die discipline op. Zo kun je een kleine en een grote discipline direct vergelijken.",
            discipline4:
              "Onder de grafiek staat een tabel met per discipline het budget, de geboekte uren, het recente tempo en het verwachte einde. 'Overig' bundelt de kleinste disciplines als het er meer dan zeven zijn; 'Zonder discipline' zijn uren op een taak die niet onder een discipline valt.",
            legendIntro: "Onder de grafiek staat de legenda. Daarmee bepaal je wat je ziet:",
            legendExample: {
              a: "Discipline A",
              b: "Discipline B",
              c: "Discipline C",
            },
            legendExampleCaption:
              "Voorbeeld: na een dubbelklik op Discipline A worden de andere lichter weergegeven en verborgen in de grafiek.",
            legend: {
              click: { label: "Klik", text: "zet dat onderdeel aan of uit." },
              doubleClick: { label: "Dubbelklik", text: "toont alleen dat onderdeel; alle andere worden verborgen." },
              restore: {
                label: "Alles weer tonen",
                text: "dubbelklik nog een keer op hetzelfde (enige zichtbare) onderdeel. Je hoeft de andere dus niet één voor één weer aan te klikken.",
              },
              other: {
                label: "Dubbelklik op een ander onderdeel",
                text: "toont alleen dát onderdeel. Zo spring je snel van de ene naar de andere discipline.",
              },
              touch: { label: "Telefoon of tablet", text: "tikken op een onderdeel werkt als klikken." },
            },
            legendGrouped:
              "In de weergave 'Per discipline' horen de staaf, de lijn en de prognose van een discipline bij één legenda-item: je zet ze dus altijd samen aan of uit.",
            toggle:
              "Beweeg met de muis over een staaf of punt voor de exacte cijfers van die week. Je keuze tussen 'Totaal' en 'Per discipline' wordt onthouden voor de volgende keer.",
            tip1: "Vergelijk het recente tempo met het gemiddelde over de looptijd. Is het recente tempo hoger, dan versnelt het project (meestal de drukke middenfase). Is het lager, dan remt het af of loopt het naar het einde.",
            tip2: "Wil je één discipline goed bekijken? Dubbelklik erop in de legenda: de schaal past zich dan aan die discipline aan, zodat kleine disciplines niet wegvallen naast grote. Dubbelklik nog een keer om terug te gaan.",
            tip3: "In 'Per discipline': de lijn die als eerste de 100%-lijn nadert, is de discipline die als eerste over budget dreigt te gaan.",
            tip4: "Staat er 'Ligt stil sinds …'? Dan is er de laatste {weeks} weken niets geboekt. Check of dat klopt, of dat er uren op een ander project of een andere taak terecht zijn gekomen.",
            tip5: "Zie je ineens minder in de grafiek dan je verwacht? Waarschijnlijk staan er onderdelen uit in de legenda. Dubbelklik op het enige zichtbare onderdeel, of herlaad de pagina.",
            faq: {
              q1: "Waarom telt de huidige week niet mee in het tempo?",
              a1: "Veel mensen boeken hun uren pas aan het eind van de week of later. De lopende week is dus bijna altijd nog onvolledig en zou het tempo ten onrechte omlaag trekken. De uren van deze week tellen wel mee in het totaal en in het resterende budget.",
              q2: "Waarom zie ik 'Ligt stil sinds …' in plaats van een datum?",
              a2: "Er zijn de laatste {weeks} weken geen uren geboekt, dus er is geen tempo om een einddatum mee te berekenen. Zodra er weer geboekt wordt, verschijnt de prognose vanzelf weer.",
              q3: "Hoe betrouwbaar is de verwachte einddatum?",
              a3: "Het is een doortrekking van het recente tempo, geen planning. Projecten lopen meestal langzaam op, pieken in het midden en lopen aan het eind af. In die afrondingsfase daalt het tempo verder, dus dan is de datum aan de optimistische kant. Gebruik hem als signaal, niet als belofte.",
              q4: "Waarom kan ik 'Per discipline' niet kiezen?",
              a4: "De knop is alleen beschikbaar als er op meer dan één discipline uren geboekt of begroot zijn. Met één discipline zou de uitsplitsing hetzelfde tonen als 'Totaal'.",
              q5: "Welke uren tellen als geboekt?",
              a5: "Alle urenregels op het project, ook concepten en uren die nog niet zijn ingediend of goedgekeurd. Alleen geannuleerde en teruggestuurde uren tellen niet mee; een teruggestuurd uur telt weer mee zodra het is gecorrigeerd en opnieuw ingediend. Urenbudget en Trend & prognose gebruiken precies dezelfde uren, dus de totalen komen overeen. De cijfers kunnen licht afwijken van de financiële administratie in Dynamics, die uren pas na goedkeuring meetelt en correcties apart verwerkt.",
              q6: "Waarom heeft een discipline wel staven maar geen lijn?",
              a6: "Er is voor die discipline geen budget, dus er is geen percentage om te tonen. In de legenda en in de tabel staat dan 'geen budget'.",
            },
          },
        },
        detail: {
          back: "Terug naar projecten",
          unnamed: "Project",
          buttonTooltip: "Projectdetails",
        },
      },
      pwa: {
        updateAvailable: "Nieuwe versie beschikbaar",
        updateDescription: "Herlaad de app voor de nieuwste functies",
        reload: "Herladen",
        later: "Later",
      },
      help: {
        title: "Helpcentrum",
        common: {
          button: "Hulp bij deze pagina",
          title: "Hulp bij deze pagina",
          close: "Sluiten",
          subtitle: "Uitleg over alle onderdelen van Vicoma People",
          searchPlaceholder: "Zoek in het helpcentrum, bijvoorbeeld ‘productiviteit’ of ‘legenda’",
          resultCount:
            "Geen resultaten voor ‘{query}’ | 1 resultaat voor ‘{query}’ | {count} resultaten voor ‘{query}’",
          noResults: "Niets gevonden",
          noResultsHint: "Probeer een ander woord, of kies hieronder een onderwerp.",
          newTitle: "Nieuw",
          newBadge: "Nieuw",
          categoriesTitle: "Onderwerpen",
          articleCount: "geen artikelen | 1 artikel | {count} artikelen",
          pageHelpTip:
            "Op pagina's met een vraagteken rechtsboven in de balk vind je uitleg over precies die pagina. Klik erop als je ergens niet uitkomt.",
          home: "Helpcentrum",
          allTopics: "Alle onderwerpen",
          goToPage: "Naar deze pagina",
          openInHelpCenter: "Openen in het helpcentrum",
          articleNotFound:
            "Dit artikel bestaat niet (meer), of het is niet beschikbaar voor jouw account.",
          backToOverview: "Naar het overzicht",
          feedbackQuestion: "Was dit artikel nuttig?",
          feedbackYes: "Ja",
          feedbackNo: "Nee",
          feedbackThanks: "Bedankt voor je feedback!",
          feedbackThanksNegative: "Bedankt. Kom je er niet uit? Stel je vraag via",
          stillQuestions: "Nog vragen die hier niet beantwoord worden? Maak een ticket aan via",
          supportTitle: "Hulp nodig?",
          supportText:
            "Staat je vraag er niet tussen, of werkt er iets niet zoals het hoort? Maak een ticket aan in Topdesk. Vermeld op welke pagina je was en wat je zag.",
          supportButton: "Topdesk",
          adminDocsText:
            "Technische en beheerdocumentatie: rechten, groepen en instellingen van de app.",
          adminDocsButton: "Openen",
          sections: {
            whatYouSee: "Wat zie je?",
            howToRead: "Zo lees je het",
            howToUse: "Zo gebruik je het",
            tips: "Handige tips",
            faq: "Veelgestelde vragen",
          },
        },
        categories: {
          gettingStarted: {
            title: "Aan de slag",
            description: "Inloggen, de app installeren en bijwerken.",
          },
          people: {
            title: "Smoelenboek",
            description: "Collega's vinden en hun profiel bekijken.",
          },
          hours: {
            title: "Uren",
            description: "Waar je uren registreert en hoe je ze in de app terugziet.",
          },
          projects: {
            title: "Projecten",
            description: "Mijn projecten, productiviteit, urenbudget en trend & prognose.",
          },
          projectAdmin: {
            title: "Projectadministratie",
            description: "Voor beheerders: onvolledige urenregistraties opvolgen.",
          },
          general: {
            title: "Algemeen",
            description: "Skills, taal en offline gebruik.",
          },
        },
        articles: {
          hoursBudget: {
            summary:
              "Hoeveel van het urenbudget van het project al is gebruikt, per discipline en taak, en hoe je de balken leest.",
          },
          trendForecast: {
            summary:
              "Hoe de geboekte uren zich per week opbouwen, het recente tempo en de prognose, de uitsplitsing per discipline en hoe de legenda werkt.",
          },
          myProjects: {
            title: "Mijn projecten",
            summary:
              "De projecten waarop je uren hebt geboekt: je uren per klant en project, je productiviteit en snelle links naar projectmap en Teams.",
            intro:
              "Mijn projecten laat alle projecten zien waarop jij in de gekozen periode uren hebt geboekt. Bovenaan staan drie kaarten met een overzicht van je projecten, uren en productiviteit; daaronder staat een tabel met je klanten en hun projecten.",
            notManaged:
              "Let op: dit zijn de projecten waarop je zelf hebt geboekt, niet de projecten die je beheert of leidt. Heb je in de gekozen periode niet op een project geboekt, dan staat het er niet tussen.",
            toolbar: {
              title: "Bovenaan de pagina",
              period:
                "kies welke periode je wilt zien. Kies een snelkeuze (huidige week, vorige week, deze maand, vorige maand of jaar tot nu), of selecteer zelf een begin- en einddatum in de kalender en klik op Toepassen. Standaard staat hier ‘Jaar tot nu’.",
              user:
                "bekijk dezelfde pagina voor een collega. Deze keuze zie je alleen als beheerder of urenstaatbeheerder.",
            },
            cards: {
              intro: "De drie kaarten vatten de gekozen periode samen:",
              sketchAlt: "Voorbeeld van de kaart {card}",
              projects:
                "op hoeveel projecten je hebt geboekt, verdeeld in factureerbare projecten (voor een klant) en interne projecten. Het grote getal is het totaal; de balk eronder toont de verdeling.",
              hours:
                "hoeveel uur je hebt geboekt en waar die heen gingen. Met de knop Klanten / Projecten rechtsboven op de kaart wissel je tussen een verdeling per klant en per project. Het getal in het midden is het totaal aantal uren.",
              productivity:
                "het deel van je uren dat naar klantprojecten ging: uren op klantprojecten gedeeld door uren op klantprojecten plus uren op interne projecten. Het afdelingsproject, waarop je afdelingstaken boekt, is ook een intern project. Verlof en ziekte (HR-taken) tellen niet mee.",
              productivityExample:
                "Rekenvoorbeeld: 30 uur op klantprojecten, 10 uur afdelingstaken en 8 uur verlof geeft 30 ÷ (30 + 10) = 75%. Afdelingstaken verlagen je productiviteit dus wel, verlof niet.",
            },
            legend: {
              title: "De legenda onder de donuts Uren en Productiviteit",
              click: {
                label: "Klik op een item",
                text: "om dat stuk van de donut te verbergen. De rest van de donut wordt dan over de hele ring verdeeld, zodat je de overige verhouding beter ziet.",
              },
              restore: {
                label: "Weer tonen",
                text: "klik nog een keer op het lichter weergegeven item.",
              },
              center:
                "Het getal in het midden van de donut blijft het totaal van alles, ook als je items verbergt.",
              noDoubleClick:
                "Anders dan in de trendgrafiek op de projectdetailpagina heeft dubbelklikken hier geen extra functie: in de donuts zet je items één voor één aan of uit.",
            },
            table: {
              intro: "In de tabel staan je klanten, met per klant de projecten waarop je hebt geboekt.",
              expand: "Klik ergens op een klantrij om de projecten van die klant open of dicht te klappen.",
              columns: "Per project zie je:",
              columnNumberName: "het projectnummer en de projectnaam;",
              columnStatus: "de status. Actieve projecten staan bovenaan, inactieve eronder;",
              columnBilling:
                "de facturatiemethode: Regie (je uren worden gefactureerd) of Vaste prijs (er is een vaste prijs afgesproken);",
              columnBudget:
                "het urenbudget: hoeveel van de begrote uren al zijn gebruikt. Groen is binnen budget, rood is erover.",
              paging:
                "Onderaan de tabel kies je hoeveel klanten je per pagina ziet (5, 10 of 20) en blader je naar de volgende pagina.",
            },
            actions: {
              title: "Snelle acties",
              clientRow: "Op een klantrij:",
              projectRow: "Op een projectrij:",
              website: "de website van de klant openen.",
              address: "het adres van de klant openen in Google Maps.",
              folder:
                "het pad naar de projectmap tonen. Kopieer het en plak het in de adresbalk van Verkenner om de map te openen.",
              teams:
                "het Teams-team van het project openen. Er wordt gezocht naar een team met het projectnummer in de naam.",
              detail:
                "de projectdetails openen, met het urenbudget per discipline en de trend & prognose. Uitleg:",
            },
            tip1: "Controleer je uren van vorige week met de snelkeuze ‘Vorige week’ voordat je ze indient.",
            tip2: "Wissel op de kaart Uren tussen Klanten en Projecten om te zien waar je tijd heen gaat.",
            tip3: "Via het mapje op een projectrij ben je sneller in de projectmap dan via zoeken in Verkenner.",
            tip4: "Verberg in de legenda van de urenkaart je grootste klant om de verdeling over de rest beter te zien.",
            faq: {
              q1: "Waarom zie ik een project niet?",
              a1: "Je ziet alleen projecten waarop je in de gekozen periode zelf uren hebt geboekt. Kies een langere periode, bijvoorbeeld ‘Jaar tot nu’ of een eigen bereik. Uren van vóór 2025 worden op deze pagina niet geladen.",
              q2: "Waarom telt mijn verlof niet mee in mijn productiviteit?",
              a2: "Verlof en ziekte (taken die met HR- beginnen) tellen nergens mee: niet als productief en niet in het totaal. Zo daalt je productiviteit niet als je op vakantie bent. Afdelingstaken tellen wel mee in het totaal en verlagen je productiviteit.",
              q3: "Wat is het verschil tussen factureerbaar en intern?",
              a3: "Een factureerbaar (extern) project is een project voor een klant. Een intern project is een project van Vicoma zelf, zoals het afdelingsproject waarop je afdelingstaken en verlof boekt.",
              q4: "Waarom zie ik geen urenbudget of knop naar de projectdetails?",
              a4: "Het urenbudget en de projectdetails zijn alleen beschikbaar voor beheerders. Heb je ze nodig voor je werk, vraag dan toegang aan via Topdesk.",
              q5: "De Teams-knop geeft ‘No Teams found for this project’. Wat nu?",
              a5: "De knop zoekt een team waarvan de naam het projectnummer bevat. Heeft het project nog geen team, of staat het nummer niet in de naam, dan wordt er niets gevonden. Zoek het team dan zelf op in Teams.",
              q6: "Tellen uren die ik nog niet heb ingediend ook mee?",
              a6: "Ja. De pagina telt al je urenregels in de periode, ook die nog in concept staan of nog niet zijn goedgekeurd. Het totaal kan daardoor hoger zijn dan wat al is goedgekeurd.",
            },
          },
          login: {
            title: "Inloggen",
            summary: "Inloggen met je Vicoma Microsoft-account.",
            blocks: [
              {
                type: "p",
                text: "Je logt in met je Vicoma Microsoft-account, hetzelfde account als voor Outlook en Teams. Een apart wachtwoord voor deze app is er niet.",
              },
              {
                type: "steps",
                items: [
                  "Open de app en klik op Inloggen.",
                  "Kies je Vicoma-account, of vul je Vicoma e-mailadres en wachtwoord in.",
                  "Rond de extra verificatie (MFA) af als Microsoft daarom vraagt.",
                ],
              },
              {
                type: "tip",
                text: "Je blijft ingelogd tot je uitlogt of tot Microsoft je vraagt opnieuw in te loggen. Uitloggen doe je via je profielfoto rechtsboven.",
              },
            ],
          },
          loginTrouble: {
            title: "Problemen met inloggen",
            summary: "Wat je kunt doen als inloggen niet lukt.",
            blocks: [
              { type: "p", text: "Lukt inloggen niet? Loop deze stappen na:" },
              {
                type: "steps",
                items: [
                  "Controleer je internetverbinding.",
                  "Gebruik je Vicoma e-mailadres; dat eindigt op {'@'}vicoma.nl.",
                  "Controleer je wachtwoord door in te loggen op office.com. Lukt dat ook niet, dan ligt het aan je account en niet aan deze app.",
                  "Probeer een privévenster, of wis de cache en cookies van je browser.",
                ],
              },
              {
                type: "tip",
                text: "Lukt het nog steeds niet? Maak een ticket aan in Topdesk en vermeld welke foutmelding je ziet.",
              },
            ],
          },
          installApp: {
            title: "De app installeren",
            summary: "Vicoma People als app op je computer of telefoon zetten.",
            blocks: [
              {
                type: "p",
                text: "Je kunt Vicoma People installeren als app. Hij opent dan in een eigen venster zonder adresbalk, en je vindt hem terug in je startmenu of op het beginscherm van je telefoon.",
              },
              {
                type: "steps",
                items: [
                  "Zie je in het menu links, onder Help & Support, de knop Installeren met een rood stipje? Klik erop en bevestig.",
                  "Zie je die knop niet? Gebruik dan het installatie-icoon in de adresbalk van Chrome of Edge. Op een iPhone of iPad kies je in Safari: Deel → Zet op beginscherm.",
                ],
              },
              {
                type: "tip",
                text: "Is de app al geïnstalleerd, of ondersteunt je browser installeren niet, dan verschijnt de knop Installeren niet.",
              },
            ],
          },
          updateApp: {
            title: "De app bijwerken",
            summary: "Wat de melding ‘Nieuwe versie beschikbaar’ betekent.",
            blocks: [
              {
                type: "p",
                text: "Als er een nieuwe versie van de app is, zie je de melding ‘Nieuwe versie beschikbaar’. Je kiest zelf wanneer je bijwerkt:",
              },
              {
                type: "list",
                items: [
                  "Herladen: de app ververst meteen en je werkt met de nieuwste versie.",
                  "Later: je werkt verder in de huidige versie. De melding komt terug als je de app opnieuw opent.",
                ],
              },
              {
                type: "p",
                text: "Na een update verschijnt het overzicht ‘Wat is er nieuw’ met de veranderingen in de nieuwe versie.",
              },
            ],
          },
          findColleague: {
            title: "Een collega vinden",
            summary: "Zoeken, filteren en sorteren in het smoelenboek.",
            blocks: [
              { type: "p", text: "Op de startpagina (People) staan al je collega's." },
              {
                type: "list",
                items: [
                  "Typ in het zoekveld. Er wordt gezocht in alle gegevens van een collega, zoals naam, functie, afdeling, vestiging en skills.",
                  "Klik op een afdeling of skill op een kaart om direct op die afdeling of skill te zoeken.",
                  "Kies bij ‘Sorteren op’ voornaam, achternaam, afdeling, e-mail, vestiging of functietitel. Met de pijl ernaast draai je de volgorde om.",
                ],
              },
              {
                type: "tip",
                text: "Nieuwe collega's van deze maand herken je aan het lint ‘Nieuwe collega’.",
              },
            ],
          },
          profileCard: {
            title: "Het profiel van een collega",
            summary: "Wat je op de kaart van een collega ziet en kunt doen.",
            blocks: [
              { type: "p", text: "Op de kaart van een collega zie je onder andere:" },
              {
                type: "list",
                items: [
                  "naam, functie en afdeling;",
                  "vestiging en contactgegevens;",
                  "skills en expertise.",
                ],
              },
              { type: "p", text: "Wat je kunt doen:" },
              {
                type: "list",
                items: [
                  "Klik op het e-mailadres om een mail te sturen.",
                  "Klik op het telefoonnummer om te bellen (op je telefoon of met een softphone).",
                  "Klik op de profielfoto voor een grotere foto.",
                  "Klik op de afdeling of een skill om collega's met dezelfde afdeling of skill te vinden.",
                ],
              },
            ],
          },
          registerHours: {
            title: "Uren registreren",
            summary: "Waar je uren boekt en waar je ze in de app terugziet.",
            blocks: [
              {
                type: "p",
                text: "Uren registreer je in Dynamics 365. Deze app leest je uren alleen uit: je kunt hier niets boeken of wijzigen.",
              },
              { type: "h", text: "Waar zie je je uren terug?" },
              {
                type: "list",
                items: [
                  "Timesheet (menu links): al je urenregels per jaar, met filters voor de huidige week en voor verlof, en een export naar Excel.",
                  "Mijn projecten: je uren per klant en per project, en je productiviteit.",
                ],
              },
              { type: "h", text: "Kolommen en filters in de Timesheet" },
              {
                type: "p",
                text: "Rechts naast de tabel in de Timesheet staan twee tabbladen: Filters en Kolommen.",
              },
              {
                type: "list",
                items: [
                  "Filters: filter bijvoorbeeld op een project, taak of status. Klik nogmaals op het tabblad om het paneel te sluiten.",
                  "Kolommen: vink een kolom aan om die aan de tabel toe te voegen, zoals Description, Work location (kantoor, bij de klant of thuis), Customer of Hour code. Vink hem uit om hem weer weg te halen.",
                  "Na het wijzigen van de kolommen is de tabel weer ingeklapt. Gebruik 'Alles uitklappen' om alle regels te zien.",
                ],
              },
              {
                type: "tip",
                text: "De dagkolommen (Ma t/m Zo) en de namen van de tabbladen volgen de taal die je in de app kiest.",
              },
              {
                type: "tip",
                text: "Heb je net iets gewijzigd in Dynamics? Ververs de pagina om je nieuwste uren te zien.",
              },
            ],
          },
          productivity: {
            title: "Hoe wordt productiviteit berekend?",
            summary: "Welke uren meetellen, welke niet, met een rekenvoorbeeld.",
            blocks: [
              {
                type: "p",
                text: "Productiviteit is het deel van je uren dat naar klantprojecten gaat.",
              },
              {
                type: "list",
                items: [
                  "Productief: uren op klantprojecten (factureerbare, externe projecten).",
                  "Totaal: uren op klantprojecten plus uren op interne projecten. Het afdelingsproject, waarop je afdelingstaken boekt, is ook een intern project.",
                  "Verlof en ziekte (taken die met HR- beginnen) tellen nergens mee.",
                ],
              },
              {
                type: "p",
                text: "Productiviteit = uren op klantprojecten ÷ (uren op klantprojecten + uren op interne projecten) × 100%.",
              },
              {
                type: "tip",
                text: "Rekenvoorbeeld: 30 uur op klantprojecten, 10 uur afdelingstaken en 8 uur verlof geeft 30 ÷ (30 + 10) = 75%. Afdelingstaken verlagen je productiviteit dus wel, verlof niet.",
              },
              {
                type: "p",
                text: "Je eigen productiviteit zie je op de pagina Mijn projecten.",
              },
            ],
          },
          incompleteTimesheets: {
            title: "Onvolledige urenregistraties",
            summary: "Voor beheerders: zien wie zijn weekstaat nog niet compleet heeft en een herinnering sturen.",
            blocks: [
              {
                type: "p",
                text: "Deze pagina geeft beheerders en urenstaatbeheerders per week een overzicht van de weekstaten van alle medewerkers: wie compleet is, wie niet, en waarom niet.",
              },
              { type: "h", text: "Filters" },
              {
                type: "list",
                items: [
                  "Week: kies de week die je wilt bekijken.",
                  "Status: toon alleen medewerkers met een bepaalde status.",
                  "Kantoor en Afdeling: beperk het overzicht tot een vestiging of afdeling.",
                  "Zoek op naam: vind een medewerker snel.",
                ],
              },
              { type: "h", text: "Statussen" },
              {
                type: "list",
                items: [
                  "Geen uren: de medewerker heeft voor deze week nog niets ingediend.",
                  "Te weinig uren: er is minder ingediend dan de weeknorm.",
                  "Meer uren: er is meer ingediend dan de weeknorm.",
                  "Returned uren: uren zijn afgewezen en moeten opnieuw worden ingediend.",
                  "Recall requested: er is gevraagd om ingediende uren terug te trekken.",
                  "Nog niet goedgekeurd: de uren zijn ingediend maar nog niet goedgekeurd.",
                  "Compleet: de weekstaat voldoet aan de weeknorm.",
                ],
              },
              {
                type: "p",
                text: "Een chip ‘Draft’ betekent dat de medewerker uren in concept heeft staan die nog niet zijn ingediend.",
              },
              { type: "h", text: "Een herinnering sturen" },
              {
                type: "steps",
                items: [
                  "Klik bij de medewerker op het envelop-icoon.",
                  "Je mailprogramma opent met een vooraf ingevulde herinnering, met een onderwerp en tekst die passen bij de status (bijvoorbeeld hoeveel uur er nog ontbreekt).",
                  "Controleer de mail en verstuur hem zelf.",
                ],
              },
              {
                type: "warning",
                text: "Er wordt niets automatisch verstuurd: de mail gaat pas weg als jij op verzenden klikt.",
              },
            ],
          },
          skills: {
            title: "Je skills bijwerken",
            summary: "Skills toevoegen aan je profiel, zodat collega's je kunnen vinden.",
            blocks: [
              {
                type: "p",
                text: "Je skills komen uit je Microsoft 365-profiel. Zo werk je ze bij:",
              },
              {
                type: "steps",
                items: [
                  "Klik op je avatar rechtsboven.",
                  "Kies ‘Wijzig profiel’.",
                  "Klik op ‘Uw profiel bijwerken’.",
                  "Klik op ‘Info’.",
                  "Voeg nieuwe skills toe of pas bestaande aan.",
                ],
              },
              {
                type: "tip",
                text: "Heb je nog geen skills? Dan staat op je eigen kaart de knop ‘Voeg skills toe aan je profiel!’, die je direct naar je profiel brengt. Nieuwe skills zijn na een tijdje zichtbaar in de app.",
              },
            ],
          },
          compass: {
            title: "Compass: vergelijkbare projecten zoeken",
            summary: "Vind eerdere vergelijkbare werkomschrijvingen en de manuren die daarvoor zijn geoffreerd.",
            blocks: [
              {
                type: "p",
                text: "Compass zoekt in eerdere werkomschrijvingen naar projecten die lijken op een nieuwe aanvraag, en toont de manuren uit de urenspecificaties. Alleen leden van de Compass-groep zien deze pagina.",
              },
              {
                type: "warning",
                text: "Compass draait op ons eigen netwerk. Het werkt alleen op kantoor of via VPN. Klantdata verlaat ons netwerk niet.",
              },
              { type: "h", text: "Zoeken" },
              {
                type: "steps",
                items: [
                  "Beschrijf de scope van de nieuwe aanvraag in je eigen woorden (minimaal 20 tekens).",
                  "Beperk eventueel op discipline, klant, jaren en omvang in uren.",
                  "Klik op Zoeken. Elke kaart toont een vergelijkbaar project met de gelijkenis, de manuren per functie en de software-uren.",
                ],
              },
              { type: "h", text: "Uren-indicatie" },
              {
                type: "p",
                text: "Vanaf 2 projecten met uren toont Compass per functie en in totaal het minimum, de mediaan en het maximum. Haal het vinkje van een kaart weg om een project niet mee te tellen; de indicatie wordt direct opnieuw berekend. Deze getallen komen rechtstreeks uit de urenspecificaties, nooit van het taalmodel.",
              },
              {
                type: "list",
                items: [
                  "'Gedeelde urenspecificatie': de uren van dit project staan in één specificatie voor meerdere items en zijn niet toe te rekenen; het project telt daarom niet mee.",
                  "'Telt niet mee': Compass markeert dit project als ongeschikt voor de indicatie, bijvoorbeeld door een oudere revisie.",
                ],
              },
              { type: "h", text: "AI-vergelijking en feedback" },
              {
                type: "p",
                text: "'Vergelijk met AI' beschrijft de overeenkomsten en verschillen tussen je aanvraag en de aangevinkte projecten, met een advies. Beoordeel elk resultaat met Goed, Matig of Fout: daarmee wordt Compass beter.",
              },
              {
                type: "tip",
                text: "Wel op de VPN en toch de melding 'alleen beschikbaar op kantoor of via VPN'? Mogelijk vraagt je browser toestemming voor toegang tot apparaten op je lokale netwerk. Sta die toe en klik op Opnieuw proberen.",
              },
            ],
          },
          offline: {
            title: "Offline gebruik",
            summary: "Wat wel en niet werkt zonder internetverbinding.",
            blocks: [
              { type: "p", text: "De app werkt beperkt zonder internetverbinding:" },
              {
                type: "list",
                items: [
                  "Gegevens en foto's die je eerder hebt geladen, kun je bekijken.",
                  "Nieuwe gegevens worden pas weer geladen als je verbinding hebt.",
                ],
              },
              {
                type: "tip",
                text: "Voor de meeste functies heb je een actieve internetverbinding nodig.",
              },
            ],
          },
          language: {
            title: "De taal wijzigen",
            summary: "Wisselen tussen Nederlands en Engels.",
            blocks: [
              {
                type: "steps",
                items: [
                  "Klik rechtsboven op NL of EN.",
                  "De taal wisselt direct en wordt onthouden voor de volgende keer.",
                ],
              },
              { type: "p", text: "Beschikbare talen: Nederlands en Engels." },
            ],
          },
        },
      },
      projectAdmin: {
        title: "Statistieken",
        incompleteTimesheetCardTitle: "Urenweekstaten",
        allUsersCompliant:
          "Alle gebruikers voldoen aan hun wekelijkse urennorm",
        allUsersCompliantDescription: "Deze week is geen actie vereist.",
        shortage: "Tekort: {hours}u",
        sendReminder: "Herinnering versturen",
        statusHeaders: {
          incomplete: "Niet compleet",
          complete: "Compleet",
          other: "Overig",
        },
        status: {
          insufficientHours: "Te weinig uren",
          returned: "Returned uren",
          recallRequested: "Recall requested",
          noEntries: "Geen uren",
          complete: "Compleet",
          fullyApproved: "Volledig goedgekeurd",
          notYetApproved: "Nog niet goedgekeurd",
          excessHours: "Meer uren",
          all: "Alle",
        },
        filters: {
          office: "Kantoor",
          department: "Afdeling",
          status: "Status",
          selectWeek: "Selecteer week",
          searchPlaceholder: "Zoek op naam",
        },
        chips: {
          noHours: "Geen uren",
        },
        stats: {
          incompleteTimesheets: "Incomplete urenweekstaten",
          percentComplete: "Percentage urenweekstaten compleet",
          totalShortage: "Totaal tekort",
          avgProductivity: "Gemiddelde productiviteit",
          weightedAvg: "Gewogen gemiddelde",
          simpleAvg: "Simpel gemiddelde",
          vsLastWeek: "vs. vorige week",
          howCalculated: "Hoe wordt dit berekend?",
          weightedExplanation:
            "Het gewogen gemiddelde berekent productiviteit door alle factureerbare uren te delen door alle relevante uren (exclusief HR-uren zoals verlof en ziekte). Dit geeft een nauwkeuriger beeld van de totale productiviteit dan een simpel gemiddelde.",
          formula: "Formule",
          weightedBenefit:
            "Voordeel: medewerkers met meer uren hebben meer invloed op het eindcijfer, wat beter de werkelijke productiviteit van het bedrijf weerspiegelt.",
        },
        billability: "Productiviteit",
        productivity: "Productiviteit",
        empty: {
          noResultsTitle: "Geen resultaten",
          noResultsDescription:
            "Geen medewerkers gevonden met de huidige filters.",
          resetFilters: "Filters resetten",
        },
        weekstate: {
          title: "Weekstaat",
          normLabel: "Norm",
          noHoursSubmitted: "Geen uren ingediend",
          selectUserHint:
            "Selecteer een medewerker links om de weekstaat te bekijken.",
        },
        email: {
          subject: "Herinnering: Weekstaat week {week}, {year}",
          greeting: "Beste {name},",
          noEntries:
            "Je hebt nog geen uren ingediend voor week {week}, {year}.\nJouw norm is {contractHours} uur.",
          insufficientHours:
            "Je hebt {totalHours} uur ingediend voor week {week}, {year}.\nDe norm is {contractHours} uur.\nEr ontbreekt nog {shortage} uur.",
          returned:
            "Je hebt {returnedHours} afgewezen uur in week {week}, {year}.\nGelieve deze uren opnieuw in te dienen.",
          recall:
            "Er is een recall request voor {recallHours} uur in week {week}, {year}.\nGelieve deze uren te controleren.",
          closing: "Graag de weekstaat zo spoedig mogelijk compleet maken.",
          signature: "Met vriendelijke groet,\nHet Project Administratie Team",
        },
      },
      refreshData: "Ververs gegevens",
      dataFetchedAt: "Gegevens van {time}",
      close: "Sluiten",
      feedback: {
        pageTitle: "Feedback",
        intro: "Help ons de app beter te maken: stem op de features die je het liefst wilt, of deel een idee, bug of compliment. Je feedback wordt met je naam verstuurd, zodat we kunnen doorvragen.",
        poll: {
          title: "Welke features wil je als eerste?",
          subtitle: "Kies er maximaal {max}. Je kunt je stemmen altijd aanpassen.",
          votes: "geen stemmen | 1 stem | {n} stemmen",
          save: "Stemmen opslaan",
          saved: "Je stemmen zijn opgeslagen",
          saveError: "Je stemmen konden niet worden opgeslagen. Probeer het opnieuw.",
          loadError: "De poll kon niet worden geladen. Probeer het later opnieuw.",
          inProgress: "Al mee bezig",
          status: {
            planned: "Gepland",
            done: "Gerealiseerd",
          },
        },
        comment: {
          title: "Deel je feedback",
          subtitle: "Een idee, iets wat niet werkt, of iets wat je goed vindt.",
          categories: {
            idea: "Idee",
            bug: "Bug",
            praise: "Compliment",
            other: "Overig",
          },
          messageLabel: "Je bericht",
          required: "Vul een bericht in",
          tooLong: "Maximaal {max} tekens",
          sentAs: "Wordt verstuurd als {name}",
          send: "Versturen",
          sent: "Bedankt voor je feedback!",
          sendError: "Je feedback kon niet worden verstuurd. Probeer het opnieuw.",
        },
        prompt: {
          title: "Wat vind je van de app?",
          text: "We horen graag wat je in Vicoma People wilt zien. Stem op nieuwe features of deel een idee, bug of compliment. Het kost je maar een minuutje.",
          give: "Feedback geven",
          later: "Later",
          never: "Niet meer vragen",
        },
        admin: {
          title: "Alle feedback",
          exportCsv: "CSV exporteren",
          date: "Datum",
          name: "Naam",
          category: "Categorie",
          message: "Bericht",
          page: "Pagina",
          forbidden: "Je hebt geen toegang tot de feedbacklijst. Vraag of je wordt toegevoegd aan de feedback-admingroep (FEEDBACK_ADMIN_GROUP_ID in de API).",
          loadError: "De feedback kon niet worden geladen.",
        },
      },
      changelog: {
        title: "Wat is er nieuw",
        newVersion: "Nieuwe versie beschikbaar!",
        types: {
          feature: "Nieuw",
          bugfix: "Bugfix",
          improvement: "Verbeterd",
          breaking: "Breaking",
        },
      },
      aiAnalysis: {
        title: "AI Analyse",
        noData: "Geen analyse beschikbaar voor deze week",
        analyzing: "Analyseren van timesheet data...",
        summary: "Samenvatting",
        priority: "Prioriteit",
        actionItems: "Actiepunten",
        projectBreakdown: "Projectverdeling",
        leavePrediction: "Verlofprognose",
        capacityForecast: "Capaciteitsprognose",
        projectHealth: "Project gezondheid",
        patterns: "Patronen",
        anomalies: "Afwijkingen",
        predictions: "Voorspellingen",
        deviations: "Afwijkingen",
        recommendations: "Aanbevelingen",
        pattern: "Patroon",
        riskLevel: "Risiconiveau",
        currentWeekHours: "Huidige weekuren",
        recommendation: "Aanbeveling",
        forecast: "Prognose",
        utilization: "Bezetting",
        projectDiversity: "Project diversiteit",
        hours: "Uren",
        trend: "Trend",
        suggestion: "Suggestie",
        customer: "Klant",
        cached: "Gecacht",
        loading: "Laden...",
      },
      compass: {
        pageTitle: "Compass – vergelijkbare projecten",
        intro:
          "Beschrijf de scope van een nieuwe aanvraag. Compass zoekt vergelijkbare eerdere werkomschrijvingen en toont de manuren die daarvoor zijn geoffreerd.",
        mockBadge: "Mock-modus: fictieve data",
        status: {
          checking: "Verbinden met Compass…",
          unreachableTitle: "Compass is niet bereikbaar",
          unreachable: "Compass is alleen beschikbaar op kantoor of via VPN.",
          unreachableHint:
            "Wel verbonden met de VPN en zie je dit toch? Mogelijk vraagt je browser toestemming voor toegang tot apparaten op je lokale netwerk: sta die toe en probeer het opnieuw.",
          retry: "Opnieuw proberen",
          noAccessTitle: "Geen toegang",
          noAccess: "Je hebt geen toegang tot Compass. Vraag IT om je toe te voegen aan de Compass-groep.",
        },
        form: {
          scope: "Scope van de nieuwe aanvraag",
          scopePlaceholder:
            "Bijvoorbeeld: Engineering instrumentatie voor een nieuwe doseerlijn met ca. 25 transmitters, 6 regelkleppen, aanpassing DCS-I/O en loop diagrams.",
          scopeHint: "Beschrijf het werk in je eigen woorden (minimaal {min} tekens). Geen speciale syntax nodig.",
          discipline: "Discipline",
          allDisciplines: "Alle disciplines",
          client: "Klant",
          allClients: "Alle klanten",
          yearFrom: "Jaar vanaf",
          yearTo: "Jaar tot en met",
          hoursMin: "Omvang: min. uren",
          hoursMax: "Omvang: max. uren",
          language: "Taal van de scope",
          languageAuto: "Automatisch herkennen",
          languageNl: "Nederlands",
          languageEn: "Engels",
          topN: "Aantal resultaten",
          search: "Zoeken",
          reset: "Wissen",
        },
        validation: {
          scopeMin: "Vul minimaal {min} tekens in",
          yearRange: "'Jaar tot en met' mag niet vóór 'jaar vanaf' liggen",
          hoursRange: "Max. uren mag niet kleiner zijn dan min. uren",
          nonNegative: "Vul 0 of meer in",
        },
        errors: {
          unreachable: "Compass is niet bereikbaar. Controleer je VPN-verbinding en probeer het opnieuw.",
          unauthorized: "Je aanmelding voor Compass is niet geldig. Herlaad de pagina en probeer het opnieuw.",
          forbidden: "Je hebt geen toegang tot Compass.",
          validation: "Compass accepteerde de aanvraag niet. Controleer de velden en probeer het opnieuw.",
          expired: "Deze zoekopdracht is verlopen. Zoek opnieuw.",
          server: "Er ging iets mis in Compass. Probeer het later opnieuw.",
        },
        results: {
          title: "Vergelijkbare projecten",
          count: "geen resultaten | 1 resultaat | {n} resultaten",
          searchedIn: "Gezocht in: {discipline}",
          selected: "{n} geselecteerd",
          none: "Geen vergelijkbare projecten gevonden. Probeer ruimere filters of een andere omschrijving.",
          toggleHint:
            "Met het vinkje op een kaart neem je een project op in, of haal je het uit, de uren-indicatie en de AI-vergelijking.",
        },
        card: {
          item: "Item",
          revision: "Rev.",
          similarity: "Gelijkenis",
          manHours: "Manuren per functie",
          softwareHours: "Software-uren",
          hours: "Uren",
          totalMan: "Totaal manuren",
          sharedUs: "Gedeelde urenspecificatie, uren niet toegerekend",
          noHours: "Voor dit project zijn geen uren beschikbaar.",
          notCounted: "Telt niet mee",
          notCountedMultidisciplinary: "Multidisciplinair, geen uren per discipline: telt niet mee",
          disciplinePart: "Telt mee met alleen de uren van de gekozen discipline: {hours}",
          excluded: "Uitgezet",
          includeInIndication: "Meetellen in de uren-indicatie",
          showDetails: "Toon details",
          hideDetails: "Verberg details",
          ws: "Werkomschrijving",
          us: "Urenspecificatie",
        },
        feedback: {
          label: "Goede match?",
          goed: "Goed",
          matig: "Matig",
          fout: "Fout",
          sent: "Bedankt, je feedback is opgeslagen.",
          error: "Feedback kon niet worden verstuurd. Probeer het opnieuw.",
          reasonsLabel: "Wat klopt er niet? (optioneel)",
          reasons: {
            wrong_phase: "Verkeerde fase (bijv. studie i.p.v. detail engineering)",
            wrong_kind: "Verkeerde aard (nieuwbouw, ombouw, vervanging)",
            wrong_size: "Verkeerde omvang (veel groter of kleiner)",
            wrong_discipline: "Verkeerde discipline",
            wrong_topic: "Ander onderwerp of andere installatie",
            too_old: "Te oud of verouderd",
            other: "Anders",
          },
          noteLabel: "Toelichting (optioneel)",
          noteHint: "Wordt gebruikt om Compass te verbeteren. Blijft binnen Vicoma.",
          noteTooLong: "Maximaal 1000 tekens",
          saveDetails: "Reden opslaan",
        },
        indication: {
          title: "Uren-indicatie",
          subtitle: "Berekend uit de urenspecificaties van de aangevinkte projecten.",
          tooFew:
            "Voor een indicatie zijn minimaal {min} projecten met uren nodig. Nu tellen er {count} mee.",
          role: "Functie",
          min: "Min",
          median: "Mediaan",
          max: "Max",
          basis: "Op basis van",
          nOfTotal: "{count} van {total}",
          manSection: "Manuren",
          softwareSection: "Software-uren",
          totalRow: "Totaal manuren",
          basisHint:
            "Per functie tellen alleen de projecten mee die die functie hebben. 'Op basis van' laat zien hoeveel van de meetellende projecten dat zijn.",
          included: "Meetellende projecten",
          disclaimer:
            "Dit is een indicatie op basis van eerdere offertes, geen begroting. Controleer altijd de verschillen in scope.",
        },
        compare: {
          title: "AI-vergelijking",
          subtitle: "Overeenkomsten, verschillen en advies voor de {count} aangevinkte project(en).",
          button: "Vergelijk met AI",
          stop: "Stoppen",
          disclaimer:
            "Gemaakt door een taalmodel op de eigen Compass-server. Voor getallen blijft de uren-indicatie leidend.",
        },
      },
      projectIntake: {
        pageTitle: "Project intake",
        projectTitle: "Project naam",
        projectManager: "Projectmanager",
        customer: "Klant",
        contractingUnit: "Contracterende eenheid",
        billingMethod: "Factureringsmethode",
        billingTimeAndMaterial: "Regie",
        billingFixedPrice: "Vaste prijs",
        estStartDate: "Geschatte startdatum",
        estDuration: "Geschatte duur (maanden)",
        estimatedRevenue: "Geschatte omzet",
        progress: "Voortgang",
        probability: "Kans",
        teamMembers: "Teamleden",
        quoteExpSentDate: "Offerte verwacht verzonden datum",
        projectTemplate: "Projectsjabloon",
        submit: "Indienen",
        submitSuccess: "Project intake succesvol ingediend!",
        submitSuccessTitle: "Aanvraag ontvangen",
        submitSuccessMessage:
          "Dynamics 365 gaat nu de Opportunity, Quote en het Project aanmaken op basis van de door jou ingevoerde gegevens. Het Project wordt ook gekoppeld aan de Quote Line. Zodra dit proces is afgerond, ontvang je een bevestiging per e-mail. Breng in de tussentijd geen wijzigingen aan in de nieuw aangemaakte records in Dynamics 365.",
        submitError: "Project intake indienen mislukt. Probeer het opnieuw.",
        loadError: "Formulierdata laden mislukt. Ververs de pagina.",
        validation: {
          required: "Dit veld is verplicht",
          maxLength: "Maximaal {max} tekens",
          positiveInteger: "Moet een positief geheel getal zijn",
          positiveNumber: "Moet een positief getal zijn",
        },
      },
      outlookSignature: {
        title: "Outlook handtekening",
        copyToClipboard: "Kopieer handtekening naar klembord",
        copyError: "Kon handtekening niet kopiëren",
        copied: "Handtekening gekopieerd naar klembord!",
        downloadScript: "Download PowerShell script",
        downloaded: "PowerShell script gedownload!",
        downloadError: "Kon script niet downloaden",
        loading: "Laden...",
        error: "Kon handtekeninggegevens niet laden",
        preview: "Voorbeeld",
        userInfo: "Je gegevens",
        fullName: "Volledige naam",
        jobTitle: "Functie",
        email: "E-mailadres",
        officePhone: "Kantoor telefoon",
        mobilePhone: "Mobiel",
        address: "Kantooradres",
        greeting: "Met vriendelijke groet,",
      },
      admin: {
        documentation: {
          title: "Admin documentatie",
          permissionsTitle: "Rechten & Toegangsbeheer",
          roles: "Rollen",
          routeProtection: "Route Beveiliging",
          routeProtectionInfo:
            "Routes kunnen worden beveiligd met behulp van route meta-configuratie. Verschillende beveiligingsniveaus zorgen ervoor dat alleen geautoriseerde gebruikers toegang hebben tot gevoelige functies.",
          knownIssues: "Bekende Problemen",
          fullDocRef: "Volledige Documentatie",
          fullDocRefDesc:
            "Voor uitgebreide documentatie over het toegangssysteem, raadpleeg het bestand hieronder:",
          location: "Bestandslocatie",
          example: "Voorbeeld route beveiliging",
          availableMeta: "Beschikbare meta velden",
          envVar: "Omgevingsvariabele",
          azureGroup: "Azure-groep",
          note: "Opmerking",
          permissions: "Rechten",
          grantAccess: {
            title: "Iemand toegang geven",
            step1: "Open het Microsoft Entra admin center (entra.microsoft.com) → Groepen → Alle groepen.",
            step2: 'Zoek de groep van de gewenste rol (zie "Azure-groep" bij de rol hieronder).',
            step3: "Open Leden → Leden toevoegen → selecteer de gebruiker → Selecteren.",
            step4: "De gebruiker herlaadt Vicoma People (F5); de rechten gelden direct.",
            note: "Vereist eigenaarschap van de groep of de Entra-rol Groups Administrator.",
          },
          role: {
            admin: "Admin",
            adminSubtitle: "Volledige systeemtoegang",
            timesheetAdmin: "Timesheet Admin",
            timesheetAdminSubtitle: "Timesheet en analytics toegang",
            projectIntake: "Project Intake",
            projectIntakeSubtitle: "Projectbeheertoegang",
            compass: "Compass",
            compassSubtitle: "Vergelijkbare projecten en uren (lokale RAG)",
            compassNote:
              "Geen admin-uitzondering: ook full admins zonder deze groep zien Compass niet. De Compass-API doet dezelfde groepscheck server-side.",
            tester: "Tester",
            testerSubtitle: "Toegang tot functies in ontwikkeling",
            testerNote:
              'Deze rol beveiligt geen enkele route — hij toont alleen de kolom "Urenbudget" in de Projecten detailgrid. Admins zien deze kolom ook, ongeacht testerlidmaatschap.',
            timesheetAdminNote:
              "De groepen SI Management en SI Dev Admin verlenen deze rol ook via OF-logica — leden van beide groepen worden hetzelfde behandeld als Timesheet Admin.",
            timesheetAdminGroupHint:
              "Voeg iemand toe aan azg-app-people-timesheet-admin om toegang te geven. De SI-groepen zijn bestaande rolgroepen die de rol ook verlenen.",
            projectIntakeGroupNote:
              "Dit is een Dynamics 365-rolgroep: lidmaatschap geeft ook de bijbehorende Dynamics-beveiligingsrol.",
          },
          perm: {
            fullAccess: "Volledige toegang tot alle functies",
            userSelection: "Gebruikersselectie en cross-user data bekijken",
            adminRoutes: "Toegang tot alleen admin routes",
            documentationAccess: "Toegang tot admin documentatie",
            timesheetAnalytics: "Timesheet analytics en rapporten",
            incompleteSheetsAccess: "Toegang tot onvolledig timesheets beheer",
            projectManagement: "Projectbeheer functies",
            projectIntakeAccess: "Toegang tot project intake routes",
            compassAccess: "Toegang tot de Compass-pagina (/compass); werkt alleen op kantoor of via VPN",
            budgetColumnAccess:
              'Weergave van de kolom "Urenbudget" in de Projecten detailgrid',
          },
          meta: {
            requiresAdmin: "Admin of Timesheet Admin toegang vereist",
            requiresFullAdmin:
              "Alleen volledige Admin toegang (hoogste machtigingsniveau)",
            requiresProjectIntake: "Project Intake of Admin toegang vereist",
            requiresCompass: "Alleen de Compass-groep (geen admin-uitzondering)",
          },
          issue: {
            siGroups: "SI Management & SI Dev Admin Groepen",
            siGroupsDescription:
              "De groepen SI Management en SI Dev Admin verlenen momenteel Timesheet Admin rechten via OF logica. Controleer of dit opzettelijk is.",
            leaveAdmin: "Leave Admin Niet Geïmplementeerd",
            leaveAdminDescription:
              "De Leave Admin rol is momenteel niet geïmplementeerd en geeft altijd false. Indien in de toekomst nodig, vereist implementatie configuratie en route setup.",
          },
        },
      },
      dashboard: {
        title: "Admin Dashboard - Productiviteit & Metrics",
        year: "Jaar",
        office: "Kantoor",
        allOffices: "Alle",
        refresh: "Ververs data",
        hoursSuffix: "u",
        whatCounts: "Wat telt mee:",
        productivity: {
          title: "Gemiddelde Productiviteit",
          infoTitle: "Hoe wordt productiviteit berekend?",
          infoText:
            "Gemiddelde productiviteit op het dashboard is bedrijfsbreed: het percentage declarabele uren van het totaal gemaakte uren zonder verlofuren, afgerond op hele procenten.",
          calculation: "Berekening:",
          infoFooter:
            "Dit geeft een beeld van de productiviteit van het hele bedrijf, niet van individuele medewerkers.",
          subtitle: "{year} ({billable} van {total} uur)",
        },
        totalHours: {
          title: "Totaal Uren",
          subtitle: "Waarvan {billable} declarabel",
        },
        projects: {
          title: "Projecten",
          infoTitle: "Actieve Projecten",
          infoText:
            "Dit getal toont het aantal unieke projecten waar in het geselecteerde jaar tijd op is geregistreerd.",
          counts1: "Alle projecten met minimaal 1 uur registratie",
          counts2: "Gefilterd op geselecteerd kantoor (indien van toepassing)",
          counts3: "Alleen declarabele projecten",
          infoFooter:
            "Deze KPI geeft inzicht in de diversiteit en spreiding van projectwerk binnen de organisatie.",
        },
        employees: {
          title: "Medewerkers",
          infoTitle: "Actieve Medewerkers",
          infoText:
            "Dit getal toont het aantal unieke medewerkers die in het geselecteerde jaar tijd hebben geregistreerd.",
          counts1: "Medewerkers met minimaal 1 geregistreerd uur",
          counts2: "Inclusief verlof- en non-declarabele uren",
          counts3: "Gefilterd op geselecteerd kantoor (indien van toepassing)",
          infoFooter:
            "Deze KPI geeft inzicht in de omvang van het actieve personeelsbestand.",
          subtitle: "Met uren in {year}",
        },
        chart: {
          title: "Wekelijkse Productiviteit & Uren Verdeling - {year}",
          noData: "Geen data beschikbaar voor geselecteerd jaar",
          week: "Week {week}",
          billable: "Declarabel",
          nonBillable: "Non-Declarabel",
          leave: "Verlof",
          total: "Totaal",
          employees: "Medewerkers",
          billableSeries: "Declarabel (u)",
          nonBillableSeries: "Non-Declarabel (u)",
          leaveSeries: "Verlof (u)",
          productivityYear: "Productiviteit {year}",
          productivity: "Productiviteit",
          totalHours: "Totaal uren",
          weekNumber: "Weeknummer",
          hoursPerWeek: "Uren per week",
          productivityAxis: "Productiviteit (%)",
          target: "Streefwaarde (80%)",
        },
      },
    },
  },
});
